export default {
  licenseRetry: { failed: 'Lisans doğrulaması şu anda tamamlanamadı. Lütfen tekrar deneyin.', dismiss: 'Kapat' },
  locale: "tr",
  landing: {
    hero: {
      title: "Finansal Analizde Yapay Zeka Devrimi",
      subtitle: "Yapay zeka ile piyasaları anlayın, geleceği öngörün",
      cta: "Hemen Başla",
      badge: "Türkiye'nin Finansal AI Platformu",
    },
    about: {
      title: "Formind Hakkında",
      mainTitle: "Yapay Zeka Destekli Finans Asistanı",
      mainDescription:
        "Formind, Türkiye finans piyasalarına özel olarak geliştirilen yapay zekâ destekli bir finans asistanıdır. Anlık piyasa verilerini geçmiş dönem verileriyle birleştirerek finans ve yatırım dünyasına dair analiz, öngörü, raporlama ve karşılaştırma işlemlerini gerçek zamanlı olarak sunar.",
      summaryTitle: "Kurumlar İçin Akıllı Çözüm",
      summaryDescription:
        "Formind, finans ve yatırım sektöründe faaliyet gösteren kurumlara, karmaşık verileri anlamlandıran, stratejik içgörüler sunan ve bilgiye erişimi kolaylaştıran akıllı bir yapay zekâ çözümüdür.",
    },
    nav: {
      login: "Giriş",
      register: "Kayıt Ol",
      chat: "Sohbet",
    },
    chat: {
      title: "AI Chat ile Finansal Analiz",
      description:
        "Borsa verilerini anlık olarak sorgulayın, teknik ve temel analiz yapın, KAP bildirimlerini takip edin. Yapay zeka destekli chat sistemi ile finansal kararlarınızı güçlendirin.",
      feature1: "Anlık borsa verileri",
      feature2: "Teknik ve temel analiz",
      feature3: "KAP bildirimleri takibi",
      feature4: "Sektörel karşılaştırmalar",
    },
    mcp: {
      title: "Model Context Protocol (MCP)",
      description:
        "ForInvest borsa verilerini anlık olarak erişme ve bu verilerden analiz yapabilme yeteneği. MCP ile kendi AI modellerinizi entegre edin.",
      docs: "Dokümantasyon ve Tool'lar",
      card1Title: "Anlık Veri Erişimi",
      card1Desc: "Borsa verilerine gerçek zamanlı erişim",
      card2Title: "Finansal Analiz",
      card2Desc: "Otomatik analiz ve raporlama",
    },
    api: {
      title: "Token Yapısı ile API Erişimi",
      description:
        "Kendi agentic yapılarınızı kurun, finansal verileri alın ve özel uygulamalarınızı geliştirin. Token bazlı güvenli API erişimi.",
      feature1: "RESTful API",
      feature2: "Token bazlı güvenlik",
      feature3: "Agentic yapı desteği",
      feature4: "Detaylı dokümantasyon",
      cta: "API'ye Başla",
    },
    footer: "© 2025 ForAI. Tüm hakları saklıdır.",
  },
  common: {
    login: "Giriş",
    logout: "Çıkış",
    email: "E-posta",
    username: "Kullanıcı Adı",
    password: "Şifre",
    loading: "Yükleniyor...",
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    edit: "Düzenle",
    create: "Oluştur",
    update: "Güncelle",
    refresh: "Yenile",
    search: "Ara",
    filter: "Filtrele",
    close: "Kapat",
    help: "Yardım",
    confirm: "Onayla",
    yes: "Evet",
    no: "Hayır",
    active: "Aktif",
    inactive: "Pasif",
    status: "Durum",
    actions: "İşlemler",
    date: "Tarih",
    name: "Ad",
    surname: "Soyad",
    role: "Rol",
    send: "Gönder",
    expand: "Genişlet",
    collapse: "Daralt",
    show: "Göster",
    hide: "Gizle",
    optional: "Opsiyonel",
    profile: "Profil",
    menu: "Menü",
  },
  auth: {
    welcome: "ForMind'a Hoş Geldiniz",
    brandDescription: "Yapay zeka destekli finansal analiz platformu. Gerçek zamanlı piyasa verileri, teknik ve temel analiz araçlarıyla yatırım kararlarınızı güçlendirin.",
    badgeAI: "AI Destekli Analiz",
    badgeRealtime: "Gerçek Zamanlı Veri",
    badgeSecure: "Güvenli Altyapı",
    loginTitle: "Giriş",
    loginSubtitle: "Hesabınıza giriş yaparak devam edin",
    registerTitle: "Kayıt Ol",
    loggingIn: "Giriş yapılıyor...",
    registering: "Kayıt yapılıyor...",
    register: "Kayıt Ol",
    firstName: "Ad",
    lastName: "Soyad",
    usernameRequired: "Kullanıcı adı ve şifre gerekli",
    allFieldsRequired: "Tüm alanlar zorunludur",
    passwordsDoNotMatch: "Şifreler eşleşmiyor",
    loginFailed: "Giriş başarısız",
    loginError: "Giriş sırasında hata oluştu",
    registerDisabled: "Kayıt ForInvest üzerinden yönetilmektedir. Lütfen ForInvest hesabınızla giriş yapın.",
    alreadyHaveAccount: "Zaten hesabınız var mı?",
    registerSuccess: "Kayıt başarılı! Giriş yapabilirsiniz.",
    confirmPassword: "Şifre Tekrar",
  },
  dashboard: {
    welcome: "Hoş geldiniz",
    welcomeMessage: "ForMind platformuna başarıyla giriş yaptınız.",
    userInfo: "Kullanıcı Bilgileri",
    administrator: "Yönetici",
    client: "Kullanıcı",
    testUser: "Test Kullanıcısı",
  },
  sidebar: {
    home: "Ana Sayfa",
    aiChat: "AI Sohbet",
    userManagement: "Kullanıcı Yönetimi",
    benchmarks: "Benchmarklar",
    tokenPricing: "Token Fiyatlandırma",
    profile: "Profilim",
    settings: "Ayarlar",
    packageLimits: "Paket Limitleri",
  },
  header: {
  },
  chat: {
    settings: "Ayarlar",
    newChat: "Yeni Sohbet",
    history: "Geçmiş",
    starred: "Yıldızlılar",
    noConversations: "Henüz konuşma yok",
    deleteConfirm: "Bu konuşmayı silmek istediğinizden emin misiniz?",
    addStar: "Yıldıza Ekle",
    removeStar: "Yıldızdan Çıkar",
    rename: "Adını Değiştir",
    conversationName: "Konuşma Adı",
    typeMessage: "Mesajınızı yazın...",
    chatModeLabel: "Yanıt modu",
    chatModeAuto: "Otomatik",
    chatModeAutoDescription: "Soruya göre hızlı veya gelişmiş modu kendisi seçer",
    chatModeFast: "Hızlı",
    chatModeFastDescription: "Basit tek hisse sorularına hızlı yanıt verir",
    chatModeAdvanced: "Gelişmiş",
    chatModeAdvancedDescription: "Kapsamlı veya çoklu hisse sorularını çözer",
    chatModeAutoSelected: "Otomatik mod",
    chatModeFastResult: "Hızlı modda üretildi",
    chatModeAdvancedResult: "Gelişmiş modda üretildi",
    modelSelectorLabel: "Model seç",
    adaptiveThinking: "Adaptif Düşünme",
    adaptiveThinkingDescription: "Çoklu Hisse soruları ve karmaşık görevler için daha derin düşünür",
    rag: "Bilgi Bankası (RAG)",
    ragDescription: "Kendi yüklediğiniz dokümanlar yanıtlara dahil edilir. Kurumsal dokümanlar her zaman aktiftir.",
    attachMenu: "Ekle",
    attachFiles: "Dosya ekle",
    listening: "Dinliyor",
    finbotReady: "Finbot hazır",
    voiceError: "Ses hatası",
    browserNotSupported: "Tarayıcı desteklemiyor",
    finbotWaiting: "Finbot beklemede",
    hello: "Merhaba!",
    welcomeMessage:
      "ForMind asistanınızla sohbet etmeye başlayın. Yatırım ve finans konularında size yardımcı olmaktan mutluluk duyarım.",
    quickPrompts: "Hazır Promptlar - Hızlı Başlangıç",
    quickPromptsSubtitle: "Aşağıdaki örneklerden birini seçerek hemen analiz başlatabilirsiniz",
    connectionSuccessful: "Bağlantı Başarılı",
    disconnected: "Bağlantı Kesildi",
    connectionError: "Bağlantı Hatası",
    wsConnectionClosed: "WebSocket bağlantısı kapandı. Lütfen sayfayı yenileyin.",
    wsConnectionError: "Bağlantı hatası oluştu. Lütfen sayfayı yenileyin.",
    toolsUsed: "araç kullanıldı",
    referencesUsed: "Kullanılan Referanslar",
    referenceUsed: "kullanıldı",
    request: "İstek",
    response: "Cevap",
    tokens: "tokens",
    startSpeaking: "Konuşmaya başlayın",
    voiceHint: "Konuşmanız bittiğinde kısa bir sessizlik bırakın",
    running: "Çalışıyor",
    success: "Başarılı",
    failed: "Başarısız",
    startListening: "Dinlemeye başla",
    stopListening: "Dinlemeyi durdur",
    howCanIHelp: "Bugün size nasıl yardımcı olabilirim?",
    welcome: "Hoş geldin",
    preparedQuestionsLoadError: "Hazır sorular yüklenemedi.",
    retry: "Tekrar dene",
    preparedQuestionUnavailable: "Seçilen hazır soru artık kullanılamıyor. Liste güncellendi.",
    originalPrompt: "Orijinal Prompt",
    proposedAnalysis: "Önerilen Analiz Adımları",
    cancel: "İptal",
    proceed: "Devam Et",
    mergingResults: "Sonuçlar birleştiriliyor...",
    preparingResult: "Sonuç Hazırlanıyor",
    preparing: "Hazırlanıyor...",
    collectingData: "Verileri Topluyorum",
    toolsRunning: "Araçlar Çalışıyor",
    analyzingData: "Tüm veriler analiz ediliyor...",
    preparingAnswer: "Yanıtınız oluşturuluyor...",
    finalAnswerPreparing: "Veriler derlendi. Yanıt hazırlanıyor...",
    listenAudio: "Sesli dinle",
    downloadPDF: "PDF olarak indir",
    followUpQuestions: "Bunları sormak isteyebilirsiniz",
    like: "Beğen",
    unlike: "Beğenmedim",
    feedbackPlaceholder: "Ne yanlış gitti? (isteğe bağlı)",
    feedbackReceived: "Geri bildiriminiz alındı.",
    voiceCommandBusy: "Sesli komut şu anda işlenemiyor, lütfen mevcut yanıtı bekleyin.",
    promptRefineError: "Prompt refine edilirken hata oluştu",
    connectionFailed: "Bağlantı kurulamadı. Lütfen sayfayı yenileyin.",
    reconnecting: "Yeniden bağlanıyor...",
    ttsError: "Ses dönüşümü başarısız oldu",
    transcribing: "Ses metne dönüştürülüyor...",
    requestingMic: "Mikrofon izni isteniyor...",
    selectMicrophone: "Mikrofon seç",
    microphone: "Mikrofon",
    defaultMicrophone: "Varsayılan mikrofon",
    noMicFound: "Mikrofon bulunamadı",
    improvingPrompt: "Prompt iyileştiriliyor...",
    refinePromptToggle: "Prompt’u iyileştir",
    refinePromptDescription: "Göndermeden önce sorunu iyileştirir. Tab ile önizle.",
    refinedPromptLabel: "İyileştirildi · Orijinali göster",
    refinePromptFallback: "İyileştirme tamamlanamadı; orijinal metin kullanıldı.",
    refinePromptHint: "Prompt'u refine et (Tab)",
    goodMorning: "Günaydın",
    goodEvening: "İyi Akşamlar",
    randomGreeting1: "Nereden başlayalım?",
    randomGreeting2: "Finans değerlendirmelerine başlayalım.",
    randomGreeting3: "Sizin için ne yapabilirim?",
    randomGreeting4: "Bugün hangi analizi yapalım?",
    randomGreeting5: "Piyasalara birlikte göz atalım.",
    deleteWarning: "Bu konuşma kalıcı olarak silinecektir.",
    deleteAll: "Hepsini Sil",
    deleteAllConfirm: "Tüm konuşmaları silmek istediğinizden emin misiniz?",
    deleteAllError: "Konuşmalar silinirken bir hata oluştu.",
    conversations: "Sohbetler",
    disclaimer: {
      title: "Önemli Bilgilendirme",
      text: "AI yanlış bilgi üretebilir. Yatırım kararlarınızı vermeden önce lütfen bilgilerin doğruluğunu kontrol ediniz."
    },
    uploadFile: "Dosya Yükle",
    removeFile: "Dosyayı Kaldır",
    fileTooLarge: "Dosya boyutu 50MB'dan büyük olamaz",
    unsupportedFileType: "Desteklenmeyen dosya türü. Lütfen PDF, TXT, Word (.docx) veya Excel (.xlsx, .xls) dosyası seçin",
    fileUploadError: "Dosya yüklenirken hata oluştu",
    stopGeneration: "Üretimi durdur",
    stoppedMessage: "Yanıt durduruldu",
    stoppingGeneration: "Üretim durduruluyor...",
    generationStopped: "Üretim durduruldu",
    pleaseWait: "Mevcut işlem durduruluyor, lütfen bekleyin",
    limitExceededTitle: "Aylık Kullanım Limitiniz Doldu",
    creditExhaustedTitle: "Kullanım Krediniz Tükendi",
    creditExhaustedDesc: "Kalan kullanım krediniz bulunmuyor. Devam etmek için paketinizi inceleyebilir veya haklarınızın yenilenmesini bekleyebilirsiniz.",
    limitExceededDesc: "Bu ay için belirlenen kullanım limitinize ulaştınız. Daha fazla kullanmak için paketinizi yükseltebilirsiniz.",
    limitExceededUpgrade: "Paketi Yükselt →",
    limitExceededProDesc: "Kullanılabilir hakkınız tükendi. Ek kullanım hakkı için destek ekibiyle iletişime geçebilirsiniz.",
    limitRenewalDate: "Paket yenilenme tarihi: {date}",
  },
  profile: {
    profile: "Profil",
    title: "Profil Bilgilerim",
    loadingProfile: "Profil bilgileri yükleniyor...",
    accountInfo: "Hesap Bilgileri",
    registrationDate: "Kayıt Tarihi",
    tokenUsage: "Kredi Kullanımı",
    tokenBalance: "Kredi Bakiyesi",
    usedToday: "Bugün Kullanılan",
    totalUsage: "Toplam Kullanım",
    used: "kullanıldı",
    totalTokenUsage: "Aylık Token Kullanımı",
    monthlyTokenCost: "Aylık Maliyet",
    date: "Tarih",
    model: "Model",
    agent: "Agent",
    cost: "Maliyet",
    apiKey: "API Anahtarı",
    hide: "Gizle",
    show: "Göster",
    copy: "Kopyala",
    copiedToClipboard: "Panoya kopyalandı",
    copyFailed: "Kopyalama başarısız",
    changePassword: "Şifre Değiştir",
    currentPassword: "Mevcut Şifre",
    newPassword: "Yeni Şifre",
    confirmPassword: "Yeni Şifre Tekrar",
    changing: "Değiştiriliyor...",
    passwordChanged: "Şifre başarıyla değiştirildi",
    fillAllFields: "Lütfen tüm alanları doğru şekilde doldurun",
    errorLoadingProfile: "Profil bilgileri yüklenirken hata oluştu",
    preferences: "Tercihler",
    language: "Dil",
    security: "Güvenlik",
    agentPreferences: "Agent Tercihleri",
    customSystemPrompt: "Özel Sistem Komutları (Maksimum 1024 karakter)",
    customPromptPlaceholder:
      "AI agent'in davranışını belirtin (ör: iletişim tarzı, analiz derinliği, vb.)",
    preferencesSaved: "Tercihler başarıyla kaydedildi",
    errorSavingPreferences: "Tercihler kaydedilirken hata oluştu",
    saving: "Kaydediliyor...",
    save: "Kaydet",
    licenses: "Lisanslar",
    license: "Lisans",
    loadingLicenses: "Lisanslar yükleniyor...",
    noLicenses: "Aktif lisans bulunamadı",
    realtime: "Gerçek Zamanlı",
    endOfDay: "Gün Sonu",
    minutesDelay: "dakika gecikme",
    monthlyUsage: "Aylık Kullanım",
    limitOf: "${limit} limit",
    unlimited: "Sınırsız",
    noAccess: "Erişim Yok",
    currentPlan: "Mevcut Planınız",
    upgrade: "Yükselt",
    planDesc: {
      Free: "Temel AI sohbet deneyimi",
      Standard: "Standart borsa verileri ile analiz",
      Trade: "MKK dahil gelişmiş işlem verileri",
      Pro: "Tüm veriler, maksimum limit",
    },
    planFeature: {
      basicChat: "AI Finansal Sohbet",
      limitedUsage: "Sınırlı aylık kullanım",
      standardData: "BIST Composite & Spot verisi",
      standardUsage: "Standart aylık kullanım",
      tradeData: "BIST Composite & Spot verisi",
      mkk: "MKK verisi",
      tradeUsage: "Gelişmiş aylık kullanım",
      proData: "Tüm BIST verileri (L2, Dist, Index)",
      l2: "Derinlik (L2) verisi",
      proUsage: "Maksimum aylık kullanım",
    },
  },
  packageLimits: {
    title: "Paket Limitleri",
    subtitle: "Her lisans paketi için aylık token (maliyet) limitini belirleyin",
    loading: "Paket limitleri yükleniyor...",
    monthlyLimit: "Aylık Limit (USD)",
    unlimited: "Sınırsız (-1 girin)",
    noAccess: "Erişim Yok (0 = bloke)",
    limitHint: "Kullanıcı bu ayda ${val} harcayabilir",
    unlimitedHint: "-1 = sınırsız, 0 = erişim yok",
    save: "Kaydet",
    saving: "Kaydediliyor...",
    saveSuccess: "{pkg} paketi başarıyla güncellendi",
    saveError: "Limit kaydedilirken hata oluştu",
    loadError: "Paket limitleri yüklenemedi",
  },
  modelManagement: {
    pipelineEyebrow: "PIPELINE YAPILANDIRMASI",
    pipelineTitle: "Pipeline atamaları",
    pipelineDescription: "Her aşamaya atanacak modeli seçin. Gelişmiş ayarlar satırı açtığınızda görünür; değişiklikler otomatik kaydedilir.",
    assignedRoles: "atanmış rol",
    assignedModel: "Atanan model",
    customAssignment: "Özel atama",
    defaultAssignment: "Varsayılan",
    jevTitle: "JEV Skill Seçici",
    jevHelp: "Skill seçiminden önce JEV kullan",
    jevModel: "JEV modeli",
    selectJevModel: "JEV modeli seçin",
    jevThreshold: "Eşik (%)",
    unavailable: "kullanılamıyor",
    enabled: "Açık",
    disabled: "Kapalı",
    send: "Gönder",
    autoSaveNote: "Değişiklikler alanı bıraktığınızda otomatik kaydedilir.",
  },
  pipelineCalculator: {
    eyebrow: "PIPELINE MALİYET TAHMİNİ",
    title: "Pipeline fiyat hesaplayıcı",
    subtitle: "Atanan modelleri, token senaryosunu ve paket limitlerine etkisini birlikte hesaplayın.",
    loading: "Model fiyatları yükleniyor...",
    refresh: "Fiyatları yenile",
    errorTitle: "Fiyatlar alınamadı",
    retry: "Tekrar dene",
    errorDescription: "Pipeline fiyat bilgileri şu anda alınamıyor.",
    runsLabel: "Çalıştırma sayısı",
    runsHint: "Seçilen dönem için toplam pipeline çalıştırması",
    cacheIncluded: "Cache tokenları input toplamına dahil",
    cacheIncludedHint: "AgentCore maliyet formülüyle uyumlu",
    priceUnit: "Fiyat birimi",
    roleBreakdown: "ROL BAZLI HESAP",
    roleBreakdownTitle: "Pipeline maliyet dağılımı",
    roleBreakdownHint: "Rolü açarak çağrı ve token senaryosunu düzenleyin",
    unavailable: "Fiyat yok",
    perRun: "/ çalıştırma",
    customAssignment: "Özel atama",
    defaultAssignment: "Varsayılan model",
    priceUnavailable: "Bu model için fiyat bulunamadı",
    callsLabel: "Çağrı / çalıştırma",
    inputLabel: "Input token / çağrı",
    outputLabel: "Output token / çağrı",
    cachedInputLabel: "Cached input / çağrı",
    cacheWriteLabel: "Cache write / çağrı",
    roleEstimate: "Bu rolün tahmini maliyeti",
    run: "çalıştırma",
    needsPrice: "Fiyat bilgisi gerekli",
    estimatedTotal: "Tahmini toplam maliyet",
    runs: "çalıştırma",
    incompleteWarning: "Fiyatı bulunmayan roller toplamın dışında bırakıldı.",
    perRunTotal: "Çalıştırma başına bilinen toplam",
    knownCost: "Fiyatı bulunan rollerin toplamı",
    modelBreakdown: "Model bazlı dağılım",
    noModels: "Hesaplanabilir model bulunamadı.",
    packageImpact: "Paket limit etkisi",
    monthly: "senaryo",
    unlimited: "Sınırsız",
    disclaimer: "Bu değerler tahmini senaryodur; gerçek maliyet, gerçekleşen token kullanımı ve pipeline akışına göre değişir.",
    noModel: "Model atanmadı",
  },
  tokenPricing: {
    title: "Token Fiyatlandırma",
    subtitle: "AI model token fiyatlarını yönetin",
    inputTokenPrice: "Input Token Fiyatı",
    outputTokenPrice: "Output Token Fiyatı",
    loadFailed: "Fiyatlar yüklenemedi",
    saveSuccess: "Fiyatlar başarıyla kaydedildi",
    saveFailed: "Kaydetme başarısız",
    saveAll: "Tümünü Kaydet",
    saveAllSuccess: "Tüm fiyatlar kaydedildi",
    totalModels: "Toplam Model",
    avgInputPrice: "Ort. Input Fiyatı",
    avgOutputPrice: "Ort. Output Fiyatı",
    exampleCost: "10M Token Maliyet",
    priceComparison: "Model Fiyat Karşılaştırması",
    estimatedCostChart: "Tahmini Maliyet Grafiği",
    examplePrompt: "Örnek Prompt",
    samplePromptText: "BIST 100 endeksindeki en yüksek hacimli 5 hisseyi analiz et",
    estimatedInput: "Tahmini Input",
    estimatedOutput: "Tahmini Output",
    estimatedCostPerPrompt: "Tahmini Maliyet / Prompt",
    priceCalculator: "Fiyat Hesaplayıcı",
    selectModel: "Model Seçin",
    inputTokenCount: "Input Token Sayısı",
    outputTokenCount: "Output Token Sayısı",
    inputCost: "Input Maliyeti",
    outputCost: "Output Maliyeti",
    totalCost: "Toplam Maliyet",
    modelPrices: "Model Fiyatları",
    model: "Model",
    status: "Durum",
    cost10M: "10M Token Maliyet",
  },
  users: {
    availableCredit: "Kullanılabilir Bakiye",
    walletBalance: "Cüzdan Toplamı",
    additionalCreditHint: "Eklenen kredi paket hakkına ek kullanım sağlar. Kullanılmayan ek kredi sonraki dönemlere taşınır.",
    title: "Kullanıcı Yönetimi",
    newUser: "Yeni Kullanıcı",
    bulkAdd: "Toplu Ekle",
    bulkAddTitle: "Toplu Üye Ekle",
    bulkJsonFile: "JSON Dosyası",
    bulkParsedCount: "{count} kayıt bulundu",
    bulkTokenNote: "Tüm kayıtlar müşteri rolünde ve günlük 5.000.000 token limitiyle oluşturulur.",
    bulkErrorTitle: "Hatalar",
    bulkMissingEmail: "Email yok",
    bulkExpiryRequired: "Secret key geçerlilik tarihi seçilmelidir",
    bulkCreate: "Toplu Oluştur",
    bulkCreating: "Toplu Oluşturuluyor...",
    bulkInvalidFormat: "JSON formatı liste (array) olmalıdır",
    bulkInvalidJson: "JSON dosyası okunamadı",
    bulkNoUsers: "Toplu ekleme için kayıt bulunamadı",
    bulkSuccess: "{count} kullanıcı başarıyla oluşturuldu",
    bulkPartial: "{created} kullanıcı oluşturuldu, {failed} hata",
    bulkAllFailed: "Hiç kullanıcı oluşturulamadı",
    bulkError: "Toplu kullanıcı oluşturulurken hata oluştu",
    tokenBalance: "Kredi Bakiyesi",
    dailyTokenUsage: "Bugün Kullanılan",
    totalTokenUsage: "Toplam Kullanım",
    createUser: "Yeni Kullanıcı Oluştur",
    editUser: "Kullanıcı Düzenle",
    changeUserPassword: "Kullanıcı Şifresini Değiştir",
    user: "Kullanıcı",
    regenerateKeys: "Anahtarı Yenile",
    regenerateConfirm: "kullanıcısının API anahtarlarını yenilemek istediğinizden emin misiniz?",
    deleteConfirm: "kullanıcısını silmek istediğinizden emin misiniz?",
    creating: "Oluşturuluyor...",
    updating: "Güncelleniyor...",
    userCreated: "Kullanıcı başarıyla oluşturuldu",
    userUpdated: "Kullanıcı başarıyla güncellendi",
    userDeleted: "Kullanıcı başarıyla silindi",
    keysRegenerated: "API anahtarları başarıyla yenilendi",
    newApiKey: "Yeni API Anahtarı",
    keyWarning: "Bu anahtar sadece bir kez gösterilmektedir. Lütfen güvenli bir yerde saklayın.",
    passwordsNotMatch: "Yeni şifreler eşleşmiyor",
    passwordTooShort: "Yeni şifre en az 6 karakter olmalıdır",
    passwordChangedSuccess: "Kullanıcının şifresi başarıyla değiştirildi",
    administrator: "Yönetici",
    customer: "Müşteri",
    test: "Test",
    enterNewPassword: "Yeni şifreyi girin",
    reenterNewPassword: "Yeni şifreyi tekrar girin",
    errorLoadingUsers: "Kullanıcılar yüklenirken hata oluştu",
    errorCreatingUser: "Kullanıcı oluşturulurken hata oluştu",
    errorUpdatingUser: "Kullanıcı güncellenirken hata oluştu",
    creditBalanceChanged: "Bakiye değişti. Güncel listeden kullanıcıyı tekrar açıp bakiyeyi kontrol ederek düzenleyin.",
    errorDeletingUser: "Kullanıcı silinirken hata oluştu",
    errorRegeneratingKeys: "Anahtarlar yenilenirken hata oluştu",
    errorChangingPassword: "Şifre değiştirilirken hata oluştu",
    viewChats: "Sohbetleri Görüntüle",
    chatConversations: "Chat Konuşmaları",
    loadingChats: "Sohbetler yükleniyor...",
    noChatsFound: "Bu kullanıcıya ait sohbet bulunamadı",
    untitledChat: "Başlıksız Sohbet",
    messages: "mesaj",
    assistant: "Asistan",
    errorLoadingChats: "Sohbetler yüklenirken hata oluştu",
    toolsUsed: "Kullanılan Araçlar",
    viewDetails: "Detayları Görüntüle",
    request: "İstek",
    response: "Yanıt",
    addTokens: "Kredi Ekle",
    currentBalance: "Mevcut Bakiye",
    tokenAmount: "Kredi Miktarı",
    enterTokenAmount: "Kredi miktarını giriniz",
    description: "Açıklama",
    tokenDescription: "Örn: Promosyon kredisi, ödeme, vb.",
    newBalance: "Yeni Bakiye",
    adding: "Ekleniyor...",
    invalidTokenAmount: "Geçerli bir kredi miktarı giriniz",
    errorAddingTokens: "Kredi eklenirken hata oluştu",
  },
  settings: {
    title: "Ayarlar",
    tokenPricing: "Token Fiyatlandırması",
    tokenPricePerUnit: "Token Başına Fiyat",
    currentPrice: "Mevcut Fiyat",
    newPrice: "Yeni Fiyat",
    save: "Kaydet",
    saving: "Kaydediliyor...",
    success: "Ayarlar başarıyla güncellendi",
    error: "Ayarlar güncellenirken hata oluştu",
    invalidPrice: "Lütfen geçerli bir fiyat girin",
  },
  benchmark: {
    title: "Benchmark Yönetimi",
    subtitle: "Excel yükleyerek sonuçları izleyin ve düzenleyin.",
    new: "Yeni Benchmark",
    newHint: "Excel dosyasını yükleyin, model kolonları otomatik algılanır.",
    nameLabel: "Benchmark Adı",
    namePlaceholder: "Örn: Q4 2024 Model Karşılaştırması",
    fileLabel: "Excel Dosyası",
    upload: "Yükle",
    uploading: "Yükleniyor...",
    empty: "Henüz benchmark yok.",
    detailTitle: "Benchmark Detayı",
    detailSubtitle: "Satırları düzenleyin ve HTML cevaplarını inceleyin.",
    columns: {
      name: "Benchmark Adı",
      uploadDate: "Yükleme Tarihi",
      avgScore: "Ortalama Score",
      accuracy: "Doğru/Yanlış",
      soru: "Soru",
      kategori: "Kategori",
      referansCevap: "Referans Cevap",
      referansTarihi: "Referans Tarihi",
      ajanCevabi: "Ajan Cevabı",
      score: "Score",
      reason: "Reason",
      dogruluk: "Doğruluk",
      sure: "Süre (sn)",
      actions: "İşlem"
    },
    actions: {
      open: "Aç",
      addRow: "+ Yeni Satır",
      addColumn: "+ Yeni Sütun",
      preview: "Önizle",
      edit: "Düzenle",
      save: "Kaydet",
      cancel: "İptal",
      refresh: "Yenile",
      delete: "Sil",
      deleteRow: "Satırı Sil",
      deleteColumn: "Sütunu Sil",
      settings: "Sütun Ayarları"
    },
    fields: {
      columnName: "Sütun Adı",
      cellColor: "Hücre Rengi",
      columnPosition: "Sütun Konumu",
      rowPosition: "Satır Konumu"
    },
    colors: {
      none: "Yok",
      green: "Yeşil",
      red: "Kırmızı"
    },
    positions: {
      end: "Sona Ekle",
      top: "Başa Ekle",
      afterRow: "Sonra: {label}",
      afterColumn: "Sonra: {label}"
    },
    messages: {
      uploadSuccess: "Benchmark başarıyla yüklendi.",
      updateSuccess: "Güncelleme kaydedildi.",
      addRowSuccess: "Yeni satır eklendi.",
      deleteSuccess: "Benchmark silindi.",
      deleteRowSuccess: "Satır silindi.",
      deleteColumnSuccess: "Sütun silindi.",
      addColumnSuccess: "Yeni sütun eklendi.",
      updateColumnSuccess: "Sütun güncellendi.",
      updateColorSuccess: "Hücre rengi güncellendi.",
      confirmDeleteRow: "Satır silinsin mi? ({label})",
      confirmDeleteColumn: "Sütun silinsin mi? ({label})"
    },
    errors: {
      fetchFailed: "Benchmark listesi alınamadı.",
      uploadFailed: "Benchmark yüklenemedi.",
      missingUpload: "Benchmark adı ve dosya zorunludur.",
      fetchDetailFailed: "Benchmark detayları alınamadı.",
      updateFailed: "Satır güncellenemedi.",
      addRowFailed: "Satır eklenemedi.",
      deleteFailed: "Benchmark silinemedi.",
      deleteRowFailed: "Satır silinemedi.",
      deleteColumnFailed: "Sütun silinemedi.",
      addColumnFailed: "Sütun eklenemedi.",
      updateColumnFailed: "Sütun güncellenemedi.",
      updateColorFailed: "Hücre rengi güncellenemedi."
    }
  },
  tour: {
    startTour: "Rehber Turu Başlat",
    next: "İleri",
    previous: "Geri",
    done: "Tamamla",
    close: "Kapat",
    chat: {
      newConversation: {
        title: "Yeni Sohbet",
        description:
          "Bu butona tıklayarak yeni bir sohbet başlatabilirsiniz. Her yeni sohbet temiz bir sayfa açar.",
      },
      history: {
        title: "Sohbet Geçmişi",
        description:
          "Önceki sohbetlerinize buradan ulaşabilirsiniz. Sohbetlerinizi yıldızlayabilir, yeniden adlandırabilir veya silebilirsiniz.",
      },
      profile: {
        title: "Profil",
        description:
          "Profil sayfanıza gitmek için bu butona tıklayın. Hesap bilgilerinizi ve tercihlerinizi buradan yönetebilirsiniz.",
      },
      examples: {
        title: "Örnek Sorular",
        description:
          "Hızlı başlangıç için hazır soru kategorilerini kullanabilirsiniz. Temel analiz, teknik analiz, piyasalar ve daha fazlası.",
      },
    },
  },
  myDocuments: {
    title: "Dokümanlarım",
    description: "Yüklediğiniz dokümanlar yalnızca sizin sohbetlerinizde kullanılır. Başka kullanıcılar göremez.",
    supportedTypes: "TXT, Markdown ve PDF",
    quota: "doküman",
    upload: {
      title: "Doküman yükle",
      description: "Dosya başına en fazla {size} MB. TXT, Markdown ve PDF desteklenir.",
      choose: "Dosya seç",
      submit: "Yükle",
      uploading: "Yükleniyor…",
      limitReached: "{limit} doküman limitine ulaştınız. Yeni bir doküman yüklemek için önce bir tanesini silin.",
    },
    list: {
      title: "Yüklediğiniz dokümanlar",
      refresh: "Yenile",
      loading: "Dokümanlar yükleniyor…",
      empty: "Henüz doküman yüklemediniz.",
      chunks: "{count} parça",
      delete: "Sil",
      deleteLabel: "{name} dokümanını sil",
      deleteConfirm: "\"{name}\" dokümanı silinsin mi?",
    },
    notifications: {
      uploaded: "\"{name}\" yüklendi.",
      replaced: "\"{name}\" güncellendi.",
      deleted: "\"{name}\" silindi.",
    },
  },
  rag: {
    chunking: {
      title: "Bölümleme (chunking)",
      description: "Doküman kaydedilmeden önce nasıl parçalanacağını belirleyin. Önizleme, kaydedilecek parçaların aynısını gösterir.",
      strategy: "Strateji",
      strategies: {
        recursive: "Özyinelemeli",
        paragraph: "Paragraf",
        sentence: "Cümle",
        fixed: "Sabit uzunluk",
        markdown: "Markdown başlıkları",
      },
      strategyHints: {
        recursive: "Paragraf, satır, cümle ve kelime sınırlarını sırayla dener. Genel kullanım için önerilir.",
        paragraph: "Yalnızca boş satırlardan böler; uzun paragrafları sınıra göre keser.",
        sentence: "Cümleleri bölmeden sınıra kadar doldurur.",
        fixed: "Yapıyı dikkate almadan sabit genişlikte pencereler oluşturur.",
        markdown: "Önce başlıklardan böler, uzun bölümleri özyinelemeli olarak parçalar.",
      },
      chunkSize: "Parça uzunluğu (karakter)",
      chunkOverlap: "Örtüşme (karakter)",
      minChunkChars: "En küçük parça (karakter)",
      minChunkCharsHint: "Bu değerin altındaki parçalar öncekiyle birleştirilir.",
      stripWhitespace: "Parça başı ve sonundaki boşlukları kırp",
      reset: "Varsayılanlara dön",
      errors: {
        chunkSize: "Parça uzunluğu {min} ile {max} arasında olmalı.",
        chunkOverlap: "Örtüşme negatif olamaz.",
        overlapTooLarge: "Örtüşme, parça uzunluğundan küçük olmalı.",
        minChunkChars: "En küçük parça 1 ile parça uzunluğu arasında olmalı.",
      },
    },
    title: "RAG Dokümanları",
    description: "Bilinen key değerleri üzerinden taslakları ve vector kayıtlarını yönetin.",
    tabs: { label: "RAG bölümleri", list: "Vector listesi ve arama", manage: "Belge yönetimi" },
    search: { title: "Vector arama denemesi", description: "Bir sorgu göndererek en yakın kayıtları inceleyin.", query: "Sorgu", topK: "Sonuç sayısı", submit: "Ara", loading: "Aranıyor…", empty: "Sonuç bulunamadı.", distance: "Mesafe: {distance}" },
    delete: { action: "Sil", loading: "Siliniyor…", confirm: "\"{key}\" kaydı silinsin mi?", success: "Vector kaydı silindi." },
    dialog: { close: "Vector detaylarını kapat" },
    list: {
      title: "Vector kayıtları",
      description: "Sağlayıcı kayıtlarını metadata ile görüntüleyin. Ham vector verisi gösterilmez.",
      refresh: "Yenile",
      loading: "Kayıtlar yükleniyor…",
      empty: "Henüz vector kaydı bulunamadı.",
      next: "Sonraki sayfa",
      metadataCount: "{count} metadata alanı",
      dataIncluded: "Vector verisi mevcut",
      dataHidden: "Ham vector gizli",
      sourceText: "Kaynak metni",
      count: "{count} kayıt",
      caption: "RAG vector kayıtları tablosu",
      selected: "Seçildi",
      select: "Detayları aç",
      edit: "Düzenle",
      loadingDetails: "Getiriliyor…",
      noSource: "Kaynak metni yok",
      dimensions: "{count} boyut",
      dimensionsLabel: "Boyut",
      bucketLabel: "Bucket",
      selectedRecord: "Seçili kayıt",
      columns: {
        key: "Key",
        metadata: "Metadata özeti",
        source: "Kaynak metni önizlemesi",
        data: "Boyut / veri durumu",
        actions: "İşlemler"
      }
    },
    upload: {
      title: "Belge yükle",
      description: "TXT, Markdown veya PDF dosyası seçin. En fazla 10 MB.",
      selectedFile: "Seçilen dosya: {name}",
      preview: "Önizle",
      loading: "Önizleniyor…",
      unsupportedType: "Desteklenmeyen dosya türü. TXT, Markdown veya PDF seçin.",
      tooLarge: "Dosya boyutu 10 MB sınırını aşamaz."
    },
    supportedTypes: "TXT, Markdown veya PDF",
    draft: {
      title: "Taslak: {fileName}",
      summary: "{mimeType} · {count} parça",
      chunk: "Parça {number}",
      key: "Key",
      text: "Metin",
      metadata: "Metadata",
      metadataKey: "Metadata anahtarı",
      metadataValue: "Metadata değeri",
      remove: "Kaldır",
      add: "Ekle"
    },
    actions: {
      title: "Taslak işlemleri",
      confirm: "Taslağı onayla",
      confirming: "Onaylanıyor…",
      clear: "Temizle"
    },
    known: {
      title: "Bilinen key işlemleri",
      description: "Bir kaydı tablodan veya key girerek düzenleme dialogunda açın.",
      edit: "Düzenle",
      key: "Key",
      get: "Getir",
      upsert: "Güncelle",
      delete: "Sil",
      text: "Tekil upsert metni",
      metadata: "Metadata JSON",
      batchKeys: "Silinecek bilinen key'ler (satır satır)",
      deleteBatch: "Bilinen key'leri toplu sil",
      deleteConfirm: "\"{key}\" kaydı silinsin mi?",
      result: "Bilinen vector sonucu"
    },
    result: {
      title: "İşlem sonucu",
      total: "Toplam: {count}",
      succeeded: "Başarılı: {count}",
      failed: "Başarısız: {count}",
      partial: "Bazı işlemler başarısız oldu. Otomatik tekrar yapılmaz.",
      retry: "Başarısızları yeniden dene",
      dimensions: "{count} boyut",
      status: "Durum: {status}",
      batch: "batch {index}"
    },
    notifications: {
      previewReady: "Önizleme hazır. Provider kaydı oluşturulmadı.",
      confirmed: "Taslak onaylandı.",
      partial: "İşlem kısmen tamamlandı.",
      fetched: "Vector kaydı getirildi.",
      updated: "Vector kaydı güncellendi.",
      deleted: "Vector kaydı silindi.",
      notFound: "Vector kaydı silinemedi; kayıt bulunamadı.",
      batchDeleted: "Bilinen key kayıtları silindi."
    },
    errors: {
      invalidFileType: "Desteklenmeyen dosya türü.",
      emptyDocument: "Belgeden anlamlı metin çıkarılamadı.",
      fileTooLarge: "Dosya boyutu izin verilen sınırı aşıyor.",
      invalidKey: "Key geçersiz.",
      invalidMetadata: "Metadata JSON biçimi geçersiz.",
      batchLimitExceeded: "Toplu işlem sınırı aşıldı.",
      providerNotFound: "Kayıt bulunamadı.",
      providerTimeout: "Sağlayıcı zaman aşımına uğradı. Lütfen tekrar deneyin.",
      providerUnavailable: "Sağlayıcıya erişilemedi. Lütfen tekrar deneyin.",
      providerInvalidResponse: "Sağlayıcıdan geçersiz yanıt alındı.",
      documentLimitExceeded: "Doküman limitine ulaşıldı. Yeni bir doküman yüklemek için önce bir tanesini silin.",
      validation: "Girilen bilgiler geçersiz.",
      generic: "İşlem tamamlanamadı. Lütfen tekrar deneyin."
    }
  },
  widgets: {
    commons: {
      search: "Ara",
      ok: "Tamam",
      selectSymbol: "Sembol Seç",
      selectField: "Alan Seç",
      selected: "seçili",
      noResults: "Sonuç bulunamadı",
      follow: "Takip Et",
      unfollow: "Takibi Bırak",
      all: "Tümü",
      results: "sonuç"
    },
    technicalAnalysis: {
      title: "Teknik Analiz",
      "5YM": "5 Yıl (Aylık)",
      "1YW": "1 Yıl (Haftalık)",
      "6M5D": "6 Ay (5 Günlük)",
      "1MD": "1 Ay (Günlük)",
      "1D5": "1 Gün (5 Dakikalık)",
      "1H1": "1 Saat (1 Dakikalık)"
    },
    depth: {
      title: "Derinlik",
      viewDepthTransaction: "Derinlik + İşlemler",
      viewDepth: "Derinlik",
      viewTransaction: "İşlemler",
      bid: "Alış",
      ask: "Satış",
      last: "Son",
      dailyWeightedAverage: "Günlük Ağırlıklı Ortalama",
      dailyChangePercentage: "Günlük Değişim %",
      time: "Zaman",
      order: "Emir",
      quantity: "Miktar",
      total: "Toplam"
    },
    transactions: {
      time: "Zaman",
      price: "Fiyat",
      amount: "Miktar",
      dchg: "Değişim %",
      turnover: "Hacim",
      last: "Son",
      volume: "Miktar"
    },
    companyInfo: {
      title: "Şirket Bilgileri",
      code: "Kod",
      companyName: "Şirket Adı",
      establishmentDate: "Kuruluş Tarihi",
      ipoDate: "Halka Arz Tarihi",
      registeredCapital: "Kayıtlı Sermaye",
      fieldOfActivity: "Faaliyet Alanı",
      numberOfEmployee: "Çalışan Sayısı",
      generalManager: "Genel Müdür",
      contact: "İletişim",
      address: "Adres",
      phone: "Telefon",
      fax: "Faks",
      website: "Web Sitesi",
      boardMembers: "Yönetim Kurulu Üyeleri",
      shareholdersRates: "Ortaklık Yapısı",
      shareholders: "Ortaklar",
      subsidiaries: "İştirakleri & Katılımlar",
      exchangePosition: "Borsa Konumu"
    },
    levelAnalysis: {
      title: "Seviye Analizi",
      noData: "Veri bulunamadı",
      weightedAverage: "Ağırlıklı Ortalama",
      totalLot: "Toplam Lot",
      averageBid: "Ortalama Alış",
      averageAsk: "Ortalama Satış",
      price: "Fiyat",
      lot: "Lot",
      percent: "Yüzde",
      percentBid: "Alış %",
      percentAsk: "Satış %"
    },
    advancedGrid: {
      title: "Gelişmiş Tablo",
      tableView: "Tablo",
      gridView: "Kart",
      search: "Sembol ara...",
      noData: "Gösterilecek veri bulunamadı",
      addSymbol: "Sembol Ekle",
      editFields: "Alan Düzenle",
      fields: {
        E: "Sembol",
        l: "Son",
        C: "Değişim %",
        b: "Alış",
        a: "Satış",
        t: "Zaman",
        o: "Açılış",
        h: "Yüksek",
        lo: "Düşük",
        v: "Hacim",
        V: "Ciro",
        De: "Açıklama"
      }
    },
    heatMap: {
      title: "Isı Haritası",
      tableView: "Tablo",
      chartView: "Grafik",
      notFoundData: "Veri bulunamadı",
      symbol: "Sembol",
      last: "Son",
      change: "Değişim %",
      weightedAverage: "Ağırlıklı Ort. %"
    },
    rag: {
    title: "RAG Dokümanları",
    description: "Bilinen key değerleri üzerinden taslakları ve vector kayıtlarını yönetin.",
    tabs: { label: "RAG bölümleri", list: "Vector listesi ve arama", manage: "Belge yönetimi" },
    search: { title: "Vector arama denemesi", description: "Bir sorgu göndererek en yakın kayıtları inceleyin.", query: "Sorgu", topK: "Sonuç sayısı", submit: "Ara", loading: "Aranıyor…", empty: "Sonuç bulunamadı.", distance: "Mesafe: {distance}" },
    delete: { action: "Sil", loading: "Siliniyor…", confirm: "\"{key}\" kaydı silinsin mi?", success: "Vector kaydı silindi." },
    dialog: { close: "Vector detaylarını kapat" },
    list: {
      title: "Vector kayıtları",
      description: "Sağlayıcı kayıtlarını metadata ile görüntüleyin. Ham vector verisi gösterilmez.",
      refresh: "Yenile",
      loading: "Kayıtlar yükleniyor…",
      empty: "Henüz vector kaydı bulunamadı.",
      next: "Sonraki sayfa",
      metadataCount: "{count} metadata alanı",
      dataIncluded: "Vector verisi mevcut",
      dataHidden: "Ham vector gizli",
      sourceText: "Kaynak metni",
      count: "{count} kayıt",
      caption: "RAG vector kayıtları tablosu",
      selected: "Seçildi",
      select: "Detayları aç",
      edit: "Düzenle",
      loadingDetails: "Getiriliyor…",
      noSource: "Kaynak metni yok",
      dimensions: "{count} boyut",
      dimensionsLabel: "Boyut",
      bucketLabel: "Bucket",
      selectedRecord: "Seçili kayıt",
      columns: {
        key: "Key",
        metadata: "Metadata özeti",
        source: "Kaynak metni önizlemesi",
        data: "Boyut / veri durumu",
        actions: "İşlemler"
      }
    },
    upload: {
      title: "Belge yükle",
      description: "TXT, Markdown veya PDF dosyası seçin. En fazla 10 MB.",
      selectedFile: "Seçilen dosya: {name}",
      preview: "Önizle",
      loading: "Önizleniyor…",
      unsupportedType: "Desteklenmeyen dosya türü. TXT, Markdown veya PDF seçin.",
      tooLarge: "Dosya boyutu 10 MB sınırını aşamaz."
    },
    supportedTypes: "TXT, Markdown veya PDF",
    draft: {
      title: "Taslak: {fileName}",
      summary: "{mimeType} · {count} parça",
      chunk: "Parça {number}",
      key: "Key",
      text: "Metin",
      metadata: "Metadata",
      metadataKey: "Metadata anahtarı",
      metadataValue: "Metadata değeri",
      remove: "Kaldır",
      add: "Ekle"
    },
    actions: {
      title: "Taslak işlemleri",
      confirm: "Taslağı onayla",
      confirming: "Onaylanıyor…",
      clear: "Temizle"
    },
    known: {
      title: "Bilinen key işlemleri",
      description: "Bir kaydı tablodan veya key girerek düzenleme dialogunda açın.",
      edit: "Düzenle",
      key: "Key",
      get: "Getir",
      upsert: "Güncelle",
      delete: "Sil",
      text: "Tekil upsert metni",
      metadata: "Metadata JSON",
      batchKeys: "Silinecek bilinen key'ler (satır satır)",
      deleteBatch: "Bilinen key'leri toplu sil",
      deleteConfirm: "\"{key}\" kaydı silinsin mi?",
      result: "Bilinen vector sonucu"
    },
    result: {
      title: "İşlem sonucu",
      total: "Toplam: {count}",
      succeeded: "Başarılı: {count}",
      failed: "Başarısız: {count}",
      partial: "Bazı işlemler başarısız oldu. Otomatik tekrar yapılmaz.",
      retry: "Başarısızları yeniden dene",
      dimensions: "{count} boyut",
      status: "Durum: {status}",
      batch: "batch {index}"
    },
    notifications: {
      previewReady: "Önizleme hazır. Provider kaydı oluşturulmadı.",
      confirmed: "Taslak onaylandı.",
      partial: "İşlem kısmen tamamlandı.",
      fetched: "Vector kaydı getirildi.",
      updated: "Vector kaydı güncellendi.",
      deleted: "Vector kaydı silindi.",
      notFound: "Vector kaydı silinemedi; kayıt bulunamadı.",
      batchDeleted: "Bilinen key kayıtları silindi."
    },
    errors: {
      invalidFileType: "Desteklenmeyen dosya türü.",
      emptyDocument: "Belgeden anlamlı metin çıkarılamadı.",
      fileTooLarge: "Dosya boyutu izin verilen sınırı aşıyor.",
      invalidKey: "Key geçersiz.",
      invalidMetadata: "Metadata JSON biçimi geçersiz.",
      batchLimitExceeded: "Toplu işlem sınırı aşıldı.",
      providerNotFound: "Kayıt bulunamadı.",
      providerTimeout: "Sağlayıcı zaman aşımına uğradı. Lütfen tekrar deneyin.",
      providerUnavailable: "Sağlayıcıya erişilemedi. Lütfen tekrar deneyin.",
      providerInvalidResponse: "Sağlayıcıdan geçersiz yanıt alındı.",
      validation: "Girilen bilgiler geçersiz.",
      generic: "İşlem tamamlanamadı. Lütfen tekrar deneyin."
    }
  },
  symbolDetails: {
      title: "Sembol Detayı",
      follow: "Takip Et",
      unfollow: "Takibi Bırak",
      dailyChange: "Günlük Değişim",
      weeklyChange: "Haftalık Değişim",
      monthlyChange: "Aylık Değişim",
      yearlyChange: "Yıllık Değişim",
      newWindow: "Yeni Pencere",
      search: "Ara",
      fields: "Alanlar",
      chart: "Mini Grafik",
      quickOrder: "Hızlı Emir"
    }
  },
  exchanges: {
    BIST: "Borsa İstanbul",
    VIOP: "Vadeli İşlem ve Opsiyon",
    SPOT: "Spot Piyasa",
    TCMB: "Türkiye Cumhuriyet Merkez Bankası",
    FX: "Döviz",
    ForeignIndex: "Yabancı Endeksler",
    Cryptocurrency: "Kripto Para"
  },
  licenses: {
    LIC_BIST_INDEX_MINI_EXT: "BIST Endeks Mini (Genişletilmiş)",
    LIC_VIP_L1P: "VIP Level 1 Premium",
    LIC_BIST_L1P: "BIST Level 1 Premium",
    LIC_VIP_L2: "VIP Level 2",
    LIC_BIST_L2: "BIST Level 2",
    LIC_TEKNIK_ANALIZ: "Teknik Analiz",
    LIC_NEWS_PICNEWS: "Haber - PicNews",
    LIC_NEWS_FRKS_INTERNAL: "Haber - Foreks İç",
    LIC_TIME: "Zaman Verisi",
    LIC_BIST_BOND_L1P: "BIST Tahvil Level 1 Premium",
    LIC_VIP_L1_FREE: "VIP Level 1 Ücretsiz",
    LIC_EXCHANGE_BIST: "Borsa İstanbul",
    LIC_BIST_KMTP_L2: "BIST KMTP Level 2",
    LIC_CBT: "Vadeli İşlemler",
    LIC_SPOT: "Spot Piyasa",
    LIC_CUSTODY: "Saklama",
    LIC_FIDES_PARITE: "Fides Parite",
    LIC_FIDES_LIBOR: "Fides LIBOR",
    LIC_NEWS_AA: "Haber - Anadolu Ajansı",
    LIC_FIDES_INDEX: "Fides Endeks",
    LIC_INTERBANK: "Interbank",
    LIC_BIST_L2P: "BIST Level 2 Premium",
    LIC_BIST_INDEX: "BIST Endeks",
    LIC_BIST_DIST: "BIST Dağıtım",
    LIC_FXEXPLORER: "FX Explorer",
    LIC_OPSP_L1: "Opsiyon Level 1",
    LIC_OPSP_L2: "Opsiyon Level 2",
    LIC_USAGBY: "ABD Hazine Bonoları",
    LIC_CBOE_EDGX: "CBOE EDGX",
    LIC_CBOE_DXE: "CBOE DXE",
    LIC_CBOE_CXE: "CBOE CXE",
    LIC_BIST_BOND_CONSOLIDATED: "BIST Tahvil Konsolide",
    LIC_BOVESPA: "Bovespa",
    LIC_MSCI: "MSCI Endeksleri",
    LIC_PRODUCT_DESKTOP_FXPLUS: "Ürün - Desktop FX Plus",
    LIC_PRODUCT_WEB_FOREKSTRADER: "Ürün - Web ForeksTrader",
    LIC_PRODUCT_MOBILE_FOREKSTRADER: "Ürün - Mobil ForeksTrader",
    LIC_TEFASFUND_AND_EUROBOND: "TEFAS Fon ve Eurobond",
    LIC_ATHENS_INDEX: "Atina Endeksleri",
    LIC_BIST_ETP: "BIST ETP",
    LIC_VIP_BASIC: "VIP Temel",
    LIC_NEWS_KAP: "Haber - KAP",
    LIC_NEWS_FRKS: "Haber - Foreks",
    LIC_MKK: "MKK",
    LIC_NEWS_IHA: "Haber - İHA",
    LIC_SETTLEMENT: "Takas",
    LIC_BIST_KMTP_L1: "BIST KMTP Level 1",
    LIC_KYD: "KYD",
    LIC_BIST_KMTP_L1P: "BIST KMTP Level 1 Premium",
    LIC_BIST_EXT: "BIST Genişletilmiş",
    LIC_VIP_EXT: "VIP Genişletilmiş",
    LIC_BOND_EXT: "Tahvil Genişletilmiş",
    LIC_CALENDAR: "Takvim",
    LIC_DJ_INDEX: "Dow Jones Endeksleri",
    LIC_VIP_L2P: "VIP Level 2 Premium",
    LIC_PING_PONG: "Ping Pong",
    LIC_VIP_DIST: "VIP Dağıtım",
    LIC_FTSE_INDEX: "FTSE Endeksleri",
    LIC_SP_INDEX: "S&P Endeksleri",
    LIC_EUX: "Eurex",
    LIC_NIKKEI_INDEX: "Nikkei Endeksleri",
    LIC_BIST_L1: "BIST Level 1",
    LIC_SWISS_INDEX: "İsviçre Endeksleri",
    LIC_BIST_BOND_L1: "BIST Tahvil Level 1",
    LIC_BIST_INDEX_MINI_BASE: "BIST Endeks Mini (Temel)",
    LIC_VIP_L1: "VIP Level 1"
  },
  fields: {
    CODE: "Sembol",
    TIME: "Zaman",
    SERIALCODE: "Seri Kodu",
    SHORTMARKETCODE: "Piyasa Kodu",
    OPEN: "Açılış",
    VWAP: "VWAP",
    TRADETYPE: "İşlem Tipi",
    BUYERCODE: "Alıcı Kodu",
    SELLERCODE: "Satıcı Kodu",
    TRADENUMBER: "İşlem No",
    PRICE: "Fiyat",
    SIZE: "Son Hacim",
    TRADETIME: "İşlem Zamanı",
    TRANSACTIONDIRECTION: "İşlem Yönü",
    TRADEDVALUE: "İşlem Değeri",
    BIDORASKDIRECTION: "Alış veya Satış Yönü",
    LASTDIRECTION: "Son Yön",
    PREVIOUSDIRECTION: "Önceki Yön",
    LAST: "Son",
    DATEEX: "Eski Tarih",
    NETCHANGE: "Net Değişim",
    NETCHANGEPERCENT: "Net Değişim %",
    EVALUATIONDATE: "Değerleme Tarihi",
    OFFICIALCLOSE: "Resmi Kapanış",
    PROMPTDATE: "Vade Tarihi",
    PREVIOUSLAST: "Önceki Son",
    VOLUME: "Hacim",
    TURNOVER: "Ciro",
    DAILYCHANGE: "G.Değ",
    DAILYCHANGEPERCENT: "G.Değ %",
    WEEKLYCHANGE: "H.Değ",
    WEEKLYCHANGEPERCENT: "H.Değ %",
    MONTHLYCHANGE: "A.Değ",
    MONTHLYCHANGEPERCENT: "A.Değ %",
    YEARLYCHANGE: "Y.Değ",
    YEARLYCHANGEPERCENT: "Y.Değ %",
    DIRECTION: "Yön",
    BID: "Alış",
    ASK: "Satış",
    LOW: "Düşük",
    HIGH: "Yüksek",
    MIDPRICE: "Ort. Fiyat",
    VOLATILITY: "Oynaklık",
    MMCODE: "PY Kodu",
    MMBIDQUOTATION: "PY Alış Kotasyonu",
    MMASKQUOTATION: "PY Satış Kotasyonu",
    MMBIDQUOTATIONAMOUNT: "PY Alış Kotasyon Hacmi",
    MMASKQUOTATIONAMOUNT: "PY Satış Kotasyon Hacmi",
    WTDLOW: "Haftalık Düşük",
    WTDHIGH: "Haftalık Yüksek",
    PREVIOUSWEEKCLOSE: "Önceki Hafta Kapanış",
    MTDLOW: "Aylık Düşük",
    MTDHIGH: "Aylık Yüksek",
    PREVIOUSMONTHCLOSE: "Önceki Ay Kapanış",
    YTDLOW: "Yıllık Düşük",
    YTDHIGH: "Yıllık Yüksek",
    PREVIOUSYEARCLOSE: "Önceki Yıl Kapanış",
    CLOSE: "Kapanış",
    PREVIOUSCLOSE: "Önceki Kapanış",
    CLOSINGSESSIONPRICE: "Kapanış Seans Fiyatı",
    LOWERLIMIT: "Alt Limit",
    UPPERLIMIT: "Üst Limit",
    TICKSIZE: "Adım Aralığı",
    GROUP: "Grup",
    BASEPRICE: "Baz Fiyat",
    TRADINGMETHOD: "İşlem Yöntemi",
    STATUS: "Durum",
    TOTALTURNOVER: "Toplam Ciro",
    TOTALVOLUME: "Toplam Hacim",
    BIDRATIO: "Alış Oranı",
    ASKRATIO: "Satış Oranı",
    BIDVWAP: "Alış VWAP",
    BIDTOTALAMOUNT: "Alış Toplam Hacim",
    ASKVWAP: "Satış VWAP",
    ASKTOTALAMOUNT: "Satış Toplam Hacim",
    PERIODICVWAP: "Periyodik VWAP",
    BIDPRICE0: "Alış Fiyat 0",
    BIDPRICE1: "Alış Fiyat 1",
    BIDPRICE2: "Alış Fiyat 2",
    BIDPRICE3: "Alış Fiyat 3",
    BIDPRICE4: "Alış Fiyat 4",
    BIDPRICE5: "Alış Fiyat 5",
    BIDPRICE6: "Alış Fiyat 6",
    BIDPRICE7: "Alış Fiyat 7",
    BIDPRICE8: "Alış Fiyat 8",
    BIDPRICE9: "Alış Fiyat 9",
    BIDAVERAGEPRICE: "Alış Ortalama Fiyat",
    BIDAMOUNT0: "Alış Hacim 0",
    BIDAMOUNT1: "Alış Hacim 1",
    BIDAMOUNT2: "Alış Hacim 2",
    BIDAMOUNT3: "Alış Hacim 3",
    BIDAMOUNT4: "Alış Hacim 4",
    BIDAMOUNT5: "Alış Hacim 5",
    BIDAMOUNT6: "Alış Hacim 6",
    BIDAMOUNT7: "Alış Hacim 7",
    BIDAMOUNT8: "Alış Hacim 8",
    BIDAMOUNT9: "Alış Hacim 9",
    BIDAMOUNTTOTAL: "Alış Hacim Toplam",
    BIDQTY0: "Alış Adet 0",
    BIDQTY1: "Alış Adet 1",
    BIDQTY2: "Alış Adet 2",
    BIDQTY3: "Alış Adet 3",
    BIDQTY4: "Alış Adet 4",
    BIDQTY5: "Alış Adet 5",
    BIDQTY6: "Alış Adet 6",
    BIDQTY7: "Alış Adet 7",
    BIDQTY8: "Alış Adet 8",
    BIDQTY9: "Alış Adet 9",
    BIDQTYTOTAL: "Alış Adet Toplam",
    BIDTIME0: "Alış Zaman 0",
    BIDTIME1: "Alış Zaman 1",
    BIDTIME2: "Alış Zaman 2",
    BIDTIME3: "Alış Zaman 3",
    BIDTIME4: "Alış Zaman 4",
    BIDTIME5: "Alış Zaman 5",
    BIDTIME6: "Alış Zaman 6",
    BIDTIME7: "Alış Zaman 7",
    BIDTIME8: "Alış Zaman 8",
    BIDTIME9: "Alış Zaman 9",
    ASKPRICE0: "Satış Fiyat 0",
    ASKPRICE1: "Satış Fiyat 1",
    ASKPRICE2: "Satış Fiyat 2",
    ASKPRICE3: "Satış Fiyat 3",
    ASKPRICE4: "Satış Fiyat 4",
    ASKPRICE5: "Satış Fiyat 5",
    ASKPRICE6: "Satış Fiyat 6",
    ASKPRICE7: "Satış Fiyat 7",
    ASKPRICE8: "Satış Fiyat 8",
    ASKPRICE9: "Satış Fiyat 9",
    ASKAVERAGEPRICE: "Satış Ortalama Fiyat",
    ASKAMOUNT0: "Satış Hacim 0",
    ASKAMOUNT1: "Satış Hacim 1",
    ASKAMOUNT2: "Satış Hacim 2",
    ASKAMOUNT3: "Satış Hacim 3",
    ASKAMOUNT4: "Satış Hacim 4",
    ASKAMOUNT5: "Satış Hacim 5",
    ASKAMOUNT6: "Satış Hacim 6",
    ASKAMOUNT7: "Satış Hacim 7",
    ASKAMOUNT8: "Satış Hacim 8",
    ASKAMOUNT9: "Satış Hacim 9",
    ASKAMOUNTTOTAL: "Satış Hacim Toplam",
    ASKQTY0: "Satış Adet 0",
    ASKQTY1: "Satış Adet 1",
    ASKQTY2: "Satış Adet 2",
    ASKQTY3: "Satış Adet 3",
    ASKQTY4: "Satış Adet 4",
    ASKQTY5: "Satış Adet 5",
    ASKQTY6: "Satış Adet 6",
    ASKQTY7: "Satış Adet 7",
    ASKQTY8: "Satış Adet 8",
    ASKQTY9: "Satış Adet 9",
    ASKQTYTOTAL: "Satış Adet Toplam",
    ASKTIME0: "Satış Zaman 0",
    ASKTIME1: "Satış Zaman 1",
    ASKTIME2: "Satış Zaman 2",
    ASKTIME3: "Satış Zaman 3",
    ASKTIME4: "Satış Zaman 4",
    ASKTIME5: "Satış Zaman 5",
    ASKTIME6: "Satış Zaman 6",
    ASKTIME7: "Satış Zaman 7",
    ASKTIME8: "Satış Zaman 8",
    ASKTIME9: "Satış Zaman 9",
    CONTRACTS: "Kontratlar",
    WOWLOW: "HÖH Düşük",
    WOWLOWDATE: "HÖH Düşük Tarih",
    WOWHIGH: "HÖH Yüksek",
    WOWHIGHDATE: "HÖH Yüksek Tarih",
    WOWPREVIOUSCLOSE: "HÖH Önceki Kapanış",
    MOMLOW: "AÖA Düşük",
    MOMLOWDATE: "AÖA Düşük Tarih",
    MOMHIGH: "AÖA Yüksek",
    MOMHIGHDATE: "AÖA Yüksek Tarih",
    MOMPREVIOUSCLOSE: "AÖA Önceki Kapanış",
    YOYLOW: "YÖY Düşük",
    YOYLOWDATE: "YÖY Düşük Tarih",
    YOYHIGH: "YÖY Yüksek",
    YOYHIGHDATE: "YÖY Yüksek Tarih",
    YOYPREVIOUSCLOSE: "YÖY Önceki Kapanış",
    VALOR: "Valör",
    BIDRATE: "Alış Oranı",
    ASKRATE: "Satış Oranı",
    LASTTRADEDATE: "Son İşlem Tarihi",
    LASTRATE: "Son Oran",
    CY: "CY",
    DTM: "DTM",
    ACCRUEDINTEREST: "Birikmiş Faiz",
    BIDSETTLEMENTPRICE: "Alış Uzlaşma Fiyatı",
    ASKSETTLEMENTPRICE: "Satış Uzlaşma Fiyatı",
    LASTSETTLEMENTPRICE: "Son Uzlaşma Fiyatı",
    DTE: "DTE",
    SIMPLERATE: "Basit Oran",
    COMPOUNDRATE: "Bileşik Oran",
    MMVALOR: "PY Valör",
    TYPE: "Tür",
    MMQUOTATION: "PY Kotasyon",
    MMQUOTERATE: "PY Kotasyon Oranı",
    MMQUOTEAMOUNT: "PY Kotasyon Hacmi",
    CPI: "CPI",
    PREVIOUSCLOSERATE: "Önceki Kapanış Oranı",
    PREVIOUSCLOSEDATE: "Önceki Kapanış Tarihi",
    LOWRATE: "Düşük Oran",
    HIGHRATE: "Yüksek Oran",
    VALOR2: "Valör 2",
    DAYS: "Gün",
    VWAR: "VWAR",
    DATE: "Tarih",
    WTDLOWDATE: "Haftalık Düşük Tarih",
    WTDHIGHDATE: "Haftalık Yüksek Tarih",
    MTDLOWDATE: "Aylık Düşük Tarih",
    MTDHIGHDATE: "Aylık Yüksek Tarih",
    YTDLOWDATE: "Yıllık Düşük Tarih",
    YTDHIGHDATE: "Yıllık Yüksek Tarih",
    EXPIREDATE: "Vade Sonu Tarihi",
    CONTINOUSCODE: "Sürekli Kod",
    INSTRUMENT: "Enstrüman",
    BOARD: "Pano",
    SESSION: "Seans",
    PREVIOUSSETTLEMENTPRICE: "Önceki Uzlaşma Fiyatı",
    SETTLEMENTPRICE: "Uzlaşma Fiyatı",
    TOTALPREMIUM: "Toplam Prim",
    OPENINTEREST: "Açık Pozisyon",
    OPENINTERESTCHANGE: "Açık Pozisyon Değişimi",
    UNDERLYINGSECURITY: "Dayanak Varlık",
    OPTIONTYPE: "Opsiyon Tipi",
    OPTIONCLASS: "Opsiyon Sınıfı",
    STRIKEPRICE: "Kullanım Fiyatı",
    SECURITYGROUP: "Menkul Kıymet Grubu",
    SECURITYGROUPNO: "Menkul Kıymet Grup No",
    LISTINGDATE: "Kotasyon Tarihi",
    CONTRACTMULTIPLIER: "Kontrat Çarpanı",
    SETTLEMENTTYPE: "Uzlaşma Tipi",
    PARENTCONTRACT: "Ana Kontrat",
    ACTIONTYPE: "İşlem Tipi",
    MARGINPERCENTAGE: "Teminat Oranı",
    TRADINGUNITCOLLATERAL: "İşlem Birimi Teminatı",
    CONTINOUSCODE2: "Sürekli Kod 2",
    FOREKSUNDERLYINGSECURITY: "Foreks Dayanak Varlık",
    SECURITYCOUNT: "Menkul Kıymet Sayısı",
    SHORTNAME: "Kısa Ad",
    SHORTNAMEENGLISH: "Kısa Ad (İngilizce)",
    TRADECONDITION: "İşlem Koşulu",
    SOURCE: "Kaynak",
    STOCKS: "Hisse Senetleri",
    TITLE: "Başlık",
    BIDTRADETOTALVOLUME: "Alış İşlem Toplam Hacim",
    ASKTRADETOTALVOLUME: "Satış İşlem Toplam Hacim",
    BIDTRADETOTALTURNOVER: "Alış İşlem Toplam Ciro",
    ASKTRADETOTALTURNOVER: "Satış İşlem Toplam Ciro",
    PRICESTEP: "Fiyat Adımı",
    EQUILIBRIUMPRICE: "Denge Fiyatı",
    EQUILIBRIUMVOLUME: "Denge Hacmi",
    EPBIDAMOUNT: "DF Alış Hacim",
    EPASKAMOUNT: "DF Satış Hacim",
    CAPITAL: "Sermaye",
    PUBLICOFFERINGRATIO: "Halka Arz Oranı",
    INDICES: "Endeksler",
    NETCAPITAL: "Net Sermaye",
    NETPROFIT: "Net Kâr",
    LASTPERIOD: "Son Dönem",
    NOMINAL: "Nominal",
    ISIN: "ISIN",
    NETDIVIDEND: "Net Temettü",
    FREEFLOATRATE: "Serbest Dolaşım Oranı",
    LASTPERIODPROFIT: "Son Dönem Kârı",
    INDEXWEIGHT: "Endeks Ağırlığı",
    INDEXFFR: "Endeks FFR",
    ISSUER: "İhraççı",
    GROSSSETTLEMENT: "Brüt Uzlaşma",
    MARKETVALUE: "Piyasa Değeri",
    PRICEEARNING: "F/K Oranı",
    PUBLICSTOCKSIZE: "Halka Açık Hisse Adedi",
    FREEFLOATSTOCKSIZE: "Serbest Dolaşım Hisse Adedi",
    FREEFLOATMARKETVALUE: "Serbest Dolaşım Piyasa Değeri",
    EARNIGPERSHARE: "Hisse Başına Kazanç",
    DIVIDENDYIELD: "Temettü Verimi",
    PRICEBOOKVALUE: "PD/DD Oranı",
    BOOKVALUE: "Defter Değeri",
    PLASMAN: "Plasman",
    PAYOUTRATIO: "Dağıtım Oranı",
    SPREAD: "Fark",
    COUPONRATE: "Kupon Oranı",
    PRICINGSOURCE: "Fiyatlama Kaynağı",
    PRICINGSOURCENAME: "Fiyatlama Kaynak Adı",
    BESTBIDTIME: "En İyi Alış Zamanı",
    BESTASKTIME: "En İyi Satış Zamanı",
    DELTA: "Delta",
    THETA: "Theta",
    GAMMA: "Gamma",
    VEGA: "Vega",
    RHO: "Rho",
    BARRIER: "Bariyer",
    BSPRICE: "BS Fiyat",
    BSDIFF: "BS Fark",
    BSCHANGEPERCENT: "BS Değişim %",
    SETTLEMENTCHANGE: "Uzlaşma Değişimi",
    SETTLEMENTCHANGEPERCENT: "Uzlaşma Değişim %",
    XU030WEIGHT: "XU030 Weight",
    XU050WEIGHT: "XU050 Weight",
    XU100WEIGHT: "XU100 Weight",
    XUTUMWEIGHT: "XUTUM Weight",
    THEOPRICE21: "Theo Price 21",
    THEOPRICE42: "Theo Price 42",
    THEOPRICE63: "Theo Price 63",
    THEOPRICE126: "Theo Price 126",
    THEOPRICE252: "Theo Price 252",
    THEOPRICE: "Teorik Fiyat",
    THEOPRICECHANGE: "Teorik Fiyat Değişimi",
    THEOPRICECHANGEPERCENT: "Teorik Fiyat Değişim %",
    HISVOL21: "His Vol 21",
    HISVOL42: "His Vol 42",
    HISVOL63: "His Vol 63",
    HISVOL126: "His Vol 126",
    HISVOL252: "His Vol 252",
    HISVOL30: "His Vol 30",
    TOTALCAPITAL: "Toplam Sermaye",
    LIQUIDASSETS: "Likit Varlıklar",
    PORTFOLIO: "Portföy",
    EMM: "EMM",
    ASSET: "Varlık",
    NUMOFSHARES: "Hisse Sayısı",
    OUTSTANDINGSHARES: "Dolaşımdaki Hisseler",
    PARTNERCOUNT: "Ortak Sayısı",
    BILLSPERCENTAGE: "Bono Oranı",
    BONDSPERCENTAGE: "Tahvil Oranı",
    REVERSEREPOPERCENTAGE: "Ters Repo Oranı",
    EQUITYPERCENTAGE: "Hisse Oranı",
    PRIVATEDEBTSPERCENTAGE: "Özel Borç Oranı",
    FOREIGNSECPERCENTAGE: "Yabancı MK Oranı",
    OTHERPERCENTAGE: "Diğer Oranı",
    NPDEBTPERCENTAGE: "NP Borç Oranı",
    EMMPERCENTAGE: "EMM Oranı",
    DAY91: "Day 91",
    DAY182: "Day 182",
    DAY273: "Day 273",
    DAY365: "Day 365",
    DAY456: "Day 456",
    DAYGEN: "Day Gen",
    OVERNIGHTEQUAL: "Gecelik Eşit",
    FUNDTYPE: "Fon Tipi",
    SIMPLELEVERAGE: "Basit Kaldıraç",
    ACTIVELEVERAGE: "Aktif Kaldıraç",
    SPOTPRICE: "Spot Fiyat",
    SPOTPRICECHANGE: "Spot Fiyat Değişimi",
    SPOTPRICECHANGEPERCENT: "Spot Fiyat Değişim %",
    HIGHCHANGEPERCENT: "Yüksek Değişim %",
    LOWCHANGEPERCENT: "Düşük Değişim %",
    OPENCHANGEPERCENT: "Açılış Değişim %",
    FLUCTUATION: "Dalgalanma",
    VWAPCHANGE: "VWAP Değişim",
    VWAPCHANGEPERCENT: "VWAP Değişim %",
    DIFFTOTALTURNOVER: "Fark Toplam Ciro",
    DIFFTOTALTURNOVERPERCENT: "Fark Toplam Ciro %",
    WARRANTRATE: "Varant Oranı",
    OPTIONSTATUS: "Opsiyon Durumu",
    NAME: "Ad",
    DESCRIPTION: "Açıklama",
    TICKER: "Sembol Kodu",
    MARKETSECTOR: "Piyasa Sektörü",
    SECURITYTYPE: "Menkul Kıymet Tipi",
    CURRENCY: "Para Birimi",
    EXCHANGE: "Borsa",
    PRECISION: "Hassasiyet",
    EXERCISETYPE: "Kullanım Tipi",
    BIDAMOUNT: "Alış Hacim",
    ASKAMOUNT: "Satış Hacim",
    DAILYDIRECTION: "Günlük Yön",
    WOWEEKLYCHANGE: "HÖH Haftalık Değişim",
    WOWEEKLYCHANGEPERCENT: "HÖH Haftalık Değişim %",
    MOMONTHLYCHANGE: "AÖA Aylık Değişim",
    MOMONTHLYCHANGEPERCENT: "AÖA Aylık Değişim %",
    YOYEARLYCHANGE: "YÖY Yıllık Değişim",
    YOYEARLYCHANGEPERCENT: "YÖY Yıllık Değişim %",
    WTDVOLUME: "Haftalık Hacim",
    WTDTURNOVER: "Haftalık Ciro",
    MTDVOLUME: "Aylık Hacim",
    MTDTURNOVER: "Aylık Ciro",
    YTDVOLUME: "Yıllık Hacim",
    YTDTURNOVER: "Yıllık Ciro",
    WOWVOLUME: "HÖH Hacim",
    WOWTURNOVER: "HÖH Ciro",
    MOMVOLUME: "AÖA Hacim",
    MOMTURNOVER: "AÖA Ciro",
    YOYVOLUME: "YÖY Hacim",
    YOYTURNOVER: "YÖY Ciro",
    WEEKLYAVERAGEVOLUME: "Haftalık Ort. Hacim",
    WEEKLYAVERAGETURNOVER: "Haftalık Ort. Ciro",
    WEEKLYAVERAGEVOLUME2: "Haftalık Ort. Hacim 2",
    WEEKLYAVERAGETURNOVER2: "Haftalık Ort. Ciro 2",
    MONTHLYAVERAGEVOLUME: "Aylık Ort. Hacim",
    MONTHLYAVERAGETURNOVER: "Aylık Ort. Ciro",
    MONTHLYAVERAGEVOLUME2: "Aylık Ort. Hacim 2",
    MONTHLYAVERAGETURNOVER2: "Aylık Ort. Ciro 2",
    YEARLYAVERAGEVOLUME: "Yıllık Ort. Hacim",
    YEARLYAVERAGETURNOVER: "Yıllık Ort. Ciro",
    YEARLYAVERAGEVOLUME2: "Yıllık Ort. Hacim 2",
    YEARLYAVERAGETURNOVER2: "Yıllık Ort. Ciro 2",
    WAITINGBIDAMOUNT0: "Bekleyen Alış Hacim 0",
    WAITINGBIDAMOUNT1: "Bekleyen Alış Hacim 1",
    WAITINGBIDAMOUNT2: "Bekleyen Alış Hacim 2",
    WAITINGBIDAMOUNT3: "Bekleyen Alış Hacim 3",
    WAITINGBIDAMOUNT4: "Bekleyen Alış Hacim 4",
    WAITINGBIDAMOUNT5: "Bekleyen Alış Hacim 5",
    WAITINGBIDAMOUNT6: "Bekleyen Alış Hacim 6",
    WAITINGBIDAMOUNT7: "Bekleyen Alış Hacim 7",
    WAITINGBIDAMOUNT8: "Bekleyen Alış Hacim 8",
    WAITINGBIDAMOUNT9: "Bekleyen Alış Hacim 9",
    WAITINGASKAMOUNT0: "Bekleyen Satış Hacim 0",
    WAITINGASKAMOUNT1: "Bekleyen Satış Hacim 1",
    WAITINGASKAMOUNT2: "Bekleyen Satış Hacim 2",
    WAITINGASKAMOUNT3: "Bekleyen Satış Hacim 3",
    WAITINGASKAMOUNT4: "Bekleyen Satış Hacim 4",
    WAITINGASKAMOUNT5: "Bekleyen Satış Hacim 5",
    WAITINGASKAMOUNT6: "Bekleyen Satış Hacim 6",
    WAITINGASKAMOUNT7: "Bekleyen Satış Hacim 7",
    WAITINGASKAMOUNT8: "Bekleyen Satış Hacim 8",
    WAITINGASKAMOUNT9: "Bekleyen Satış Hacim 9",
    WAITINGBIDTURNOVER0: "Bekleyen Alış Ciro 0",
    WAITINGBIDTURNOVER1: "Bekleyen Alış Ciro 1",
    WAITINGBIDTURNOVER2: "Bekleyen Alış Ciro 2",
    WAITINGBIDTURNOVER3: "Bekleyen Alış Ciro 3",
    WAITINGBIDTURNOVER4: "Bekleyen Alış Ciro 4",
    WAITINGBIDTURNOVER5: "Bekleyen Alış Ciro 5",
    WAITINGBIDTURNOVER6: "Bekleyen Alış Ciro 6",
    WAITINGBIDTURNOVER7: "Bekleyen Alış Ciro 7",
    WAITINGBIDTURNOVER8: "Bekleyen Alış Ciro 8",
    WAITINGBIDTURNOVER9: "Bekleyen Alış Ciro 9",
    WAITINGASKTURNOVER0: "Bekleyen Satış Ciro 0",
    WAITINGASKTURNOVER1: "Bekleyen Satış Ciro 1",
    WAITINGASKTURNOVER2: "Bekleyen Satış Ciro 2",
    WAITINGASKTURNOVER3: "Bekleyen Satış Ciro 3",
    WAITINGASKTURNOVER4: "Bekleyen Satış Ciro 4",
    WAITINGASKTURNOVER5: "Bekleyen Satış Ciro 5",
    WAITINGASKTURNOVER6: "Bekleyen Satış Ciro 6",
    WAITINGASKTURNOVER7: "Bekleyen Satış Ciro 7",
    WAITINGASKTURNOVER8: "Bekleyen Satış Ciro 8",
    WAITINGASKTURNOVER9: "Bekleyen Satış Ciro 9",
    MARKETVALUEUSD: "Piyasa Değeri USD",
    MARKETVALUEEUR: "Piyasa Değeri EUR",
    LEVELCHANGE: "Seviye Değişimi",
    SESSIONSTARTTIME: "Seans Başlangıç Zamanı",
    SESSIONENDTIME: "Seans Bitiş Zamanı",
    SESSIONDATE: "Seans Tarihi",
    PREVIOUSSESSIONDATE: "Önceki Seans Tarihi",
    OPENFLAG: "Açık Bayrağı",
    RISKLEVEL: "Risk Seviyesi",
    GMT: "GMT",
    MATURITY: "Vade",
    SMA5: "SMA5",
    SMA10: "SMA10",
    SMA20: "SMA20",
    SMA50: "SMA50",
    SMA100: "SMA100",
    SMA200: "SMA200",
    EMA5: "EMA5",
    EMA10: "EMA10",
    EMA20: "EMA20",
    EMA50: "EMA50",
    EMA100: "EMA100",
    EMA200: "EMA200",
    RSI14: "RSI14",
    MACD122609: "MACD122609",
    BOLUP2002: "BOLUP2002",
    BOLDOWN2002: "BOLDOWN2002",
    ADX14: "ADX14",
    DABTC: "DABTC",
    DASTC: "DASTC",
    DABTQ: "DABTQ",
    DASTQ: "DASTQ",
    DABSCR: "DABSCR",
    DABSQR: "DABSQR",
    DATBSCR: "DATBSCR",
    DATBSQR: "DATBSQR",
    DAWT: "DAWT",
    DAWAT: "DAWAT",
    DAWBT: "DAWBT",
    DAWST: "DAWST",
    DAOC: "DAOC",
    DATOC: "DATOC",
    DAOQ: "DAOQ",
    DATOQ: "DATOQ",
    DABOC: "DABOC",
    DASOC: "DASOC",
    DABOQ: "DABOQ",
    DASOQ: "DASOQ",
    DAFAKC: "DAFAKC",
    DAABQ: "DAABQ",
    DAASQ: "DAASQ",
    DAVBQ: "DAVBQ",
    DAVSQ: "DAVSQ",
    DACXC: "DACXC",
    DACXQ: "DACXQ",
    DACXBC: "DACXBC",
    DACXSC: "DACXSC",
    DACXBQ: "DACXBQ",
    DACXSQ: "DACXSQ",
    DATCXC: "DATCXC",
    DAWCX: "DAWCX",
    DAWCXB: "DAWCXB",
    DAWCXS: "DAWCXS",
    DACXCR: "DACXCR",
    DACXQR: "DACXQR",
    DATCXCR: "DATCXCR",
    DATCXQR: "DATCXQR",
    M1: "M1",
    M3: "M3",
    M6: "M6",
    M12: "M12",
    OPTIONPREMIUMTURNOVER: "Opsiyon Prim Cirosu",
    LOCALE: "Dil",
    TAG: "Etiket",
    NEWSID: "Haber No",
    CONTENT: "İçerik",
    HEADER: "Başlık",
    SUMMARY: "Özet",
    TOPFIVEBROKERBIDTRADEVOLUME: "İlk 5 Aracı Alış İşlem Hacmi",
    TOPFIVEBROKERASKTRADEVOLUME: "İlk 5 Aracı Satış İşlem Hacmi",
    TOPFIVEBROKERNETTRADEVOLUME: "İlk 5 Aracı Net İşlem Hacmi",
    SNAPSHOT: "Anlık Görüntü",
    REALTRADENUMBER: "Gerçek İşlem No",
    TRADEID: "İşlem Kimliği",
    FIXINGSETTLEMENTPRICE: "Fixing Uzlaşma Fiyatı",
    PREVIOUSSETTLEMENTPRICECLOSE: "Önceki Uzlaşma Kapanış Fiyatı",
    STATE: "Durum",
    TRADEOPERATION: "İşlem Operasyonu",
    ALPHA200: "Alpha 200",
    BETA200: "Beta 200",
    EQUILIBRIUMCHANGEPERCENT: "Denge Değişim %",
    DIFFTOTALVOLUME: "Fark Toplam Hacim",
    AVERAGERATE: "Ortalama Oran",
    DATETIME: "Tarih Saat",
    ESTIMATEDBIDPRICE: "Tahmini Alış Fiyatı",
    ESTIMATEDASKPRICE: "Tahmini Satış Fiyatı",
    BIDRATE0: "Alış Oran 0",
    BIDRATE1: "Alış Oran 1",
    BIDRATE2: "Alış Oran 2",
    BIDRATE3: "Alış Oran 3",
    BIDRATE4: "Alış Oran 4",
    BIDRATE5: "Alış Oran 5",
    BIDRATE6: "Alış Oran 6",
    BIDRATE7: "Alış Oran 7",
    BIDRATE8: "Alış Oran 8",
    BIDRATE9: "Alış Oran 9",
    ASKRATE0: "Satış Oran 0",
    ASKRATE1: "Satış Oran 1",
    ASKRATE2: "Satış Oran 2",
    ASKRATE3: "Satış Oran 3",
    ASKRATE4: "Satış Oran 4",
    ASKRATE5: "Satış Oran 5",
    ASKRATE6: "Satış Oran 6",
    ASKRATE7: "Satış Oran 7",
    ASKRATE8: "Satış Oran 8",
    ASKRATE9: "Satış Oran 9",
    NOMINALOPTIONPREMIUMTURNOVER: "Nominal Opsiyon Prim Cirosu",
    TIMEMS: "Zaman Ms",
    MMQUOTETIME: "PY Kotasyon Zamanı",
    MMQUOTETYPE: "PY Kotasyon Tipi",
    DEPTHTIME: "Derinlik Zamanı",
    BIDQTY: "Alış Adet",
    ASKQTY: "Satış Adet",
    RATE: "Oran",
    OPENRATE: "Açılış Oranı",
    MMQUOTEBROKER: "PY Kotasyon Aracı",
    MBOORDERKEY: "MBO Emir Anahtarı",
    MBOBUYORSELL: "MBO Alış veya Satış",
    MBOORDERCLASS: "MBO Emir Sınıfı",
    MBOPRICE: "MBO Fiyat",
    MBOVOLUME: "MBO Hacim",
    ADDITIONALREFERENCEPRICE: "Ek Referans Fiyat",
    ACCUMULATEDTRADEREPORTVOLUME: "Birikimli İşlem Rapor Hacmi",
    TOTALTURNOVERCURRENCY: "Toplam Ciro Döviz",
    ACCUMULATEDTRADEREPORTTURNOVER: "Birikimli İşlem Rapor Cirosu",
    ACCUMULATEDTRADEREPORTTURNOVERCURRENCY: "Birikimli İşlem Rapor Ciro Döviz",
    TURNOVERCURRENCY: "Ciro Döviz",
    TOPFIVEBROKERBIDTRADETURNOVER: "İlk 5 Aracı Alış İşlem Cirosu",
    TOPFIVEBROKERASKTRADETURNOVER: "İlk 5 Aracı Satış İşlem Cirosu",
    TOPFIVEBROKERNETTRADETURNOVER: "İlk 5 Aracı Net İşlem Cirosu",
    TOPTENBROKERBIDTRADEVOLUME: "İlk 10 Aracı Alış İşlem Hacmi",
    TOPTENBROKERASKTRADEVOLUME: "İlk 10 Aracı Satış İşlem Hacmi",
    TOPTENBROKERNETTRADEVOLUME: "İlk 10 Aracı Net İşlem Hacmi",
    TOPTENBROKERBIDTRADETURNOVER: "İlk 10 Aracı Alış İşlem Cirosu",
    TOPTENBROKERASKTRADETURNOVER: "İlk 10 Aracı Satış İşlem Cirosu",
    TOPTENBROKERNETTRADETURNOVER: "İlk 10 Aracı Net İşlem Cirosu",
    VWAPRATE: "VWAP Rate",
    VWAPSETTLEMENT: "VWAP Settlement",
    VWAPCOMPOUNDRATE: "VWAP Compound Rate",
    ATTACHMENTS: "Ekler",
    BIDCOLLATERALPRICE0: "Alış Teminat Fiyat 0",
    BIDCOLLATERALPRICE1: "Alış Teminat Fiyat 1",
    BIDCOLLATERALPRICE2: "Alış Teminat Fiyat 2",
    BIDCOLLATERALPRICE3: "Alış Teminat Fiyat 3",
    BIDCOLLATERALPRICE4: "Alış Teminat Fiyat 4",
    BIDCOLLATERALPRICE5: "Alış Teminat Fiyat 5",
    BIDCOLLATERALPRICE6: "Alış Teminat Fiyat 6",
    BIDCOLLATERALPRICE7: "Alış Teminat Fiyat 7",
    BIDCOLLATERALPRICE8: "Alış Teminat Fiyat 8",
    BIDCOLLATERALPRICE9: "Alış Teminat Fiyat 9",
    ASKCOLLATERALPRICE0: "Satış Teminat Fiyat 0",
    ASKCOLLATERALPRICE1: "Satış Teminat Fiyat 1",
    ASKCOLLATERALPRICE2: "Satış Teminat Fiyat 2",
    ASKCOLLATERALPRICE3: "Satış Teminat Fiyat 3",
    ASKCOLLATERALPRICE4: "Satış Teminat Fiyat 4",
    ASKCOLLATERALPRICE5: "Satış Teminat Fiyat 5",
    ASKCOLLATERALPRICE6: "Satış Teminat Fiyat 6",
    ASKCOLLATERALPRICE7: "Satış Teminat Fiyat 7",
    ASKCOLLATERALPRICE8: "Satış Teminat Fiyat 8",
    ASKCOLLATERALPRICE9: "Satış Teminat Fiyat 9",
    COLLATERALPRICE: "Teminat Fiyatı",
    TOPBIDTRADEBROKER: "En İyi Alış Aracı",
    TOPASKTRADEBROKER: "En İyi Satış Aracı",
    TOPTOTALTRADEBROKER: "En İyi Toplam Aracı",
    DAILYRATECHANGE: "Günlük Oran Değişimi",
    PIVOT: "Pivot",
    SUPPORT1: "Destek 1",
    SUPPORT2: "Destek 2",
    RESISTANCE1: "Direnç 1",
    RESISTANCE2: "Direnç 2",
    EQUILIBRIUMTURNOVER: "Denge Cirosu",
    OPENCOMPOUNDRATE: "Açılış Bileşik Oran",
    HIGHCOMPOUNDRATE: "Yüksek Bileşik Oran",
    LOWCOMPOUNDRATE: "Düşük Bileşik Oran",
    SEQUENCEID: "Sıra No",
    MBOTIME: "MBO Zaman",
    MBOUPDATECODE: "MBO Güncelleme Kodu",
    PUBLICLEASECERTPERCENTAGE: "Kamu Kira Sertifikası Oranı",
    PRIVATELEASECERTPERCENTAGE: "Özel Kira Sertifikası Oranı",
    PRECIOUSMETALSPERCENTAGE: "Kıymetli Maden Oranı",
    BANKBONDSPERCENTAGE: "Banka Bonosu Oranı",
    FOREIGNBILLSOFEXCPERCENTAGE: "Yabancı Bono Oranı",
    FOREIGNDEPTHSOFEXCPERCENTAGE: "Yabancı Borç Oranı",
    EUROBONDSPERCENTAGE: "Eurobond Oranı",
    COMMERCIALPAPERSPERCENTAGE: "Finansman Bonosu Oranı",
    FUNDCERTPERCENTAGE: "Fon Katılma Belgesi Oranı",
    REALESTATECERTPERCENTAGE: "Gayrimenkul Sertifikası Oranı",
    PARTICIPATIONACCPERCENTAGE: "Katılım Hesabı Oranı",
    DERIVATIVESPERCENTAGE: "Türev Oranı",
    ASSETBACKEDSECPERCENTAGE: "Varlığa Dayalı MK Oranı",
    TERMDEPOSITPERCENTAGE: "Vadeli Mevduat Oranı",
    FOREIGNDEBTSPERCENTAGE: "Yabancı Borçlar Oranı",
    FOREIGNEQUITYPERCENTAGE: "Yabancı Hisse Oranı",
    REPOPERCENTAGE: "Repo Oranı",
    CROSSTRADE: "Çapraz İşlem",
    TRADABLESTATUS: "İşlem Durumu",
    SENSITIVITY: "Hassasiyet",
    AUCTIONPRICE: "T. Açılış",
    AUCTIONVOLUME: "T. Açılış Hacim",
    FINALEVALUATION: "Son Değerleme",
    GRAPHIC: "Grafik",
    FGOLDD: "Gold D",
    FGOLD60M: "Gold D 60M",
    FGOLD15M: "Gold D 15M",
    FGOLD5M: "Gold D 5M",
    LEGACYCODE: "Eski Kod",
    RANKEDBIDPRICE0: "Sıralı Alış Fiyat 0",
    RANKEDBIDPRICE1: "Sıralı Alış Fiyat 1",
    RANKEDBIDPRICE2: "Sıralı Alış Fiyat 2",
    RANKEDBIDPRICE3: "Sıralı Alış Fiyat 3",
    RANKEDBIDPRICE4: "Sıralı Alış Fiyat 4",
    RANKEDBIDPRICE5: "Sıralı Alış Fiyat 5",
    RANKEDBIDPRICE6: "Sıralı Alış Fiyat 6",
    RANKEDBIDPRICE7: "Sıralı Alış Fiyat 7",
    RANKEDBIDPRICE8: "Sıralı Alış Fiyat 8",
    RANKEDBIDPRICE9: "Sıralı Alış Fiyat 9",
    RANKEDBIDAMOUNT0: "Sıralı Alış Hacim 0",
    RANKEDBIDAMOUNT1: "Sıralı Alış Hacim 1",
    RANKEDBIDAMOUNT2: "Sıralı Alış Hacim 2",
    RANKEDBIDAMOUNT3: "Sıralı Alış Hacim 3",
    RANKEDBIDAMOUNT4: "Sıralı Alış Hacim 4",
    RANKEDBIDAMOUNT5: "Sıralı Alış Hacim 5",
    RANKEDBIDAMOUNT6: "Sıralı Alış Hacim 6",
    RANKEDBIDAMOUNT7: "Sıralı Alış Hacim 7",
    RANKEDBIDAMOUNT8: "Sıralı Alış Hacim 8",
    RANKEDBIDAMOUNT9: "Sıralı Alış Hacim 9",
    RANKEDBIDORDERKEY0: "Sıralı Alış Emir Anahtarı 0",
    RANKEDBIDORDERKEY1: "Sıralı Alış Emir Anahtarı 1",
    RANKEDBIDORDERKEY2: "Sıralı Alış Emir Anahtarı 2",
    RANKEDBIDORDERKEY3: "Sıralı Alış Emir Anahtarı 3",
    RANKEDBIDORDERKEY4: "Sıralı Alış Emir Anahtarı 4",
    RANKEDBIDORDERKEY5: "Sıralı Alış Emir Anahtarı 5",
    RANKEDBIDORDERKEY6: "Sıralı Alış Emir Anahtarı 6",
    RANKEDBIDORDERKEY7: "Sıralı Alış Emir Anahtarı 7",
    RANKEDBIDORDERKEY8: "Sıralı Alış Emir Anahtarı 8",
    RANKEDBIDORDERKEY9: "Sıralı Alış Emir Anahtarı 9",
    RANKEDASKPRICE0: "Sıralı Satış Fiyat 0",
    RANKEDASKPRICE1: "Sıralı Satış Fiyat 1",
    RANKEDASKPRICE2: "Sıralı Satış Fiyat 2",
    RANKEDASKPRICE3: "Sıralı Satış Fiyat 3",
    RANKEDASKPRICE4: "Sıralı Satış Fiyat 4",
    RANKEDASKPRICE5: "Sıralı Satış Fiyat 5",
    RANKEDASKPRICE6: "Sıralı Satış Fiyat 6",
    RANKEDASKPRICE7: "Sıralı Satış Fiyat 7",
    RANKEDASKPRICE8: "Sıralı Satış Fiyat 8",
    RANKEDASKPRICE9: "Sıralı Satış Fiyat 9",
    RANKEDASKAMOUNT0: "Sıralı Satış Hacim 0",
    RANKEDASKAMOUNT1: "Sıralı Satış Hacim 1",
    RANKEDASKAMOUNT2: "Sıralı Satış Hacim 2",
    RANKEDASKAMOUNT3: "Sıralı Satış Hacim 3",
    RANKEDASKAMOUNT4: "Sıralı Satış Hacim 4",
    RANKEDASKAMOUNT5: "Sıralı Satış Hacim 5",
    RANKEDASKAMOUNT6: "Sıralı Satış Hacim 6",
    RANKEDASKAMOUNT7: "Sıralı Satış Hacim 7",
    RANKEDASKAMOUNT8: "Sıralı Satış Hacim 8",
    RANKEDASKAMOUNT9: "Sıralı Satış Hacim 9",
    RANKEDASKORDERKEY0: "Sıralı Satış Emir Anahtarı 0",
    RANKEDASKORDERKEY1: "Sıralı Satış Emir Anahtarı 1",
    RANKEDASKORDERKEY2: "Sıralı Satış Emir Anahtarı 2",
    RANKEDASKORDERKEY3: "Sıralı Satış Emir Anahtarı 3",
    RANKEDASKORDERKEY4: "Sıralı Satış Emir Anahtarı 4",
    RANKEDASKORDERKEY5: "Sıralı Satış Emir Anahtarı 5",
    RANKEDASKORDERKEY6: "Sıralı Satış Emir Anahtarı 6",
    RANKEDASKORDERKEY7: "Sıralı Satış Emir Anahtarı 7",
    RANKEDASKORDERKEY8: "Sıralı Satış Emir Anahtarı 8",
    RANKEDASKORDERKEY9: "Sıralı Satış Emir Anahtarı 9",
    MMQUOTEUPDATECODE: "PY Kotasyon Güncelleme Kodu",
    CLEARINGTRADEINFO: "Takas İşlem Bilgisi",
    LIVESTATUS: "Canlı Durum",
    TOPFIVEBROKERBIDTRADEVOLUME5M: "İlk 5 Aracı Alış Hacim 5dk",
    TOPFIVEBROKERASKTRADEVOLUME5M: "İlk 5 Aracı Satış Hacim 5dk",
    TOPFIVEBROKERNETTRADEVOLUME5M: "İlk 5 Aracı Net Hacim 5dk",
    TOPFIVEBROKERBIDTRADETURNOVER5M: "İlk 5 Aracı Alış Ciro 5dk",
    TOPFIVEBROKERASKTRADETURNOVER5M: "İlk 5 Aracı Satış Ciro 5dk",
    TOPFIVEBROKERNETTRADETURNOVER5M: "İlk 5 Aracı Net Ciro 5dk",
    TOPFIVEBROKERBIDTRADEVOLUME10M: "İlk 5 Aracı Alış Hacim 10dk",
    TOPFIVEBROKERASKTRADEVOLUME10M: "İlk 5 Aracı Satış Hacim 10dk",
    TOPFIVEBROKERNETTRADEVOLUME10M: "İlk 5 Aracı Net Hacim 10dk",
    TOPFIVEBROKERBIDTRADETURNOVER10M: "İlk 5 Aracı Alış Ciro 10dk",
    TOPFIVEBROKERASKTRADETURNOVER10M: "İlk 5 Aracı Satış Ciro 10dk",
    TOPFIVEBROKERNETTRADETURNOVER10M: "İlk 5 Aracı Net Ciro 10dk",
    CAPITALRATIO: "Sermaye Oranı",
    SHORTDEBTONTOTALASSETS: "Kısa Vadeli Borç / Toplam Varlık",
    SHORTDEBTONTOTALDEBT: "Kısa Vadeli Borç / Toplam Borç",
    RETURNONEQUITY: "Özsermaye Kârlılığı",
    SESSIONHIGH: "Seans Yüksek",
    SESSIONLOW: "Seans Düşük",
    SESSIONOPEN: "Seans Açılış",
    SESSIONCHANGE: "Seans Değişim",
    SESSIONCHANGEPERCENT: "Seans Değişim %",
    SESSIONTOTALVOLUME: "Seans Toplam Hacim",
    SESSIONTOTALTURNOVER: "Seans Toplam Ciro",
    SESSIONTOTALTURNOVERCURRENCY: "Seans Toplam Ciro Döviz",
    SESSIONVWAP: "Seans VWAP",
    SESSIONCONTRACTS: "Seans Kontratlar",
    BESTBID: "En İyi Alış",
    BESTASK: "En İyi Satış",
    BIDTRADECOUNT: "Alış İşlem Sayısı",
    ASKTRADECOUNT: "Satış İşlem Sayısı",
    UPTICKCOUNT: "Artış Sayısı",
    UPTICKVOLUME: "Artış Hacmi",
    UPTICKTURNOVER: "Artış Cirosu",
    DOWNTICKCOUNT: "Düşüş Sayısı",
    DOWNTICKVOLUME: "Düşüş Hacmi",
    DOWNTICKTURNOVER: "Düşüş Cirosu",
    SMA8: "SMA 8",
    EMA8: "EMA 8",
    PUBLICDOMESTICDEBTPERCENTAGE: "Kamu İç Borç Oranı",
    PUBLICLEASEFCPERCENTAGE: "Kamu Kira Döviz Oranı",
    REALESTATEINVESTMENTFUNDSPERCENTAGE: "Gayrimenkul Yatırım Fonu Oranı",
    PUBLICFOREIGNLEASEPERCENTAGE: "Kamu Dış Kira Oranı",
    DEPOSITFCPERCENTAGE: "Mevduat Döviz Oranı",
    PARTICIPATIONACCOUNTFCPERCENTAGE: "Katılım Hesabı Döviz Oranı",
    DEPOSITTLPERCENTAGE: "Mevduat TL Oranı",
    PSFOREIGNLEASEPERCENTAGE: "ÖS Dış Kira Oranı",
    FOREIGNPUBLICDEBTPERCENTAGE: "Yabancı Kamu Borç Oranı",
    PRIVATEEXTERNALBORROWINGPERCENTAGE: "Özel Dış Borçlanma Oranı",
    TRADEDFUNDSPARTICIPATIONPERCENTAGE: "İşlem Gören Fon Katılım Oranı",
    PUBLICDEBTPRECIOUSMETALSPERCENTAGE: "Kamu Borç Kıymetli Maden Oranı",
    FOREIGNTRADEDFUNDSPERCENTAGE: "Yabancı İşlem Gören Fon Oranı",
    PARTICIPATIONACCOUNTAUPERCENTAGE: "Katılım Hesabı Altın Oranı",
    FOREIGNPRIVATESECTORDEBTPERCENTAGE: "Yabancı Özel Sektör Borç Oranı",
    MUTUALFUNDSPARTICIPATIONPERCENTAGE: "Yatırım Fonu Katılım Oranı",
    DEPOSITAUPERCENTAGE: "Mevduat Altın Oranı",
    PARTICIPATIONACCOUNTTLPERCENTAGE: "Katılım Hesabı TL Oranı",
    FUTURESCASHCOLLATERALSPERCENTAGE: "Vadeli Nakit Teminat Oranı",
    PRECIOUSMETALSETFPERCENTAGE: "Kıymetli Maden ETF Oranı",
    PRIVATEEQUITYINVESTMENTFUNDSPERCENTAGE: "Girişim Sermayesi Yatırım Fonu Oranı",
    PUBLICLEASETLPERCENTAGE: "Kamu Kira TL Oranı",
    PUBLICLEASEPRECIOUSMETALSPERCENTAGE: "Kamu Kira Kıymetli Maden Oranı",
    BIDPRICE10: "Alış Fiyat 10",
    BIDQTY20: "Alış Adet 20",
    BIDQTY24: "Alış Adet 24",
    ASKPRICE13: "Satış Fiyat 13",
    ASKPRICE17: "Satış Fiyat 17",
    BIDQTY11: "Alış Adet 11",
    BIDQTY15: "Alış Adet 15",
    ASKPRICE10: "Satış Fiyat 10",
    ASKPRICE14: "Satış Fiyat 14",
    ASKAMOUNT10: "Satış Hacim 10",
    BIDPRICE13: "Alış Fiyat 13",
    ASKPRICE21: "Satış Fiyat 21",
    BIDPRICE21: "Alış Fiyat 21",
    BIDAMOUNT15: "Alış Hacim 15",
    BIDAMOUNT16: "Alış Hacim 16",
    ASKPRICE23: "Satış Fiyat 23",
    ASKAMOUNT12: "Satış Hacim 12",
    ASKAMOUNT13: "Satış Hacim 13",
    ASKAMOUNT18: "Satış Hacim 18",
    ASKQTY17: "Satış Adet 17",
    ASKQTY23: "Satış Adet 23",
    BIDPRICE12: "Alış Fiyat 12",
    BIDQTY22: "Alış Adet 22",
    BIDAMOUNT18: "Alış Hacim 18",
    BIDQTY23: "Alış Adet 23",
    ASKQTY21: "Satış Adet 21",
    ASKPRICE20: "Satış Fiyat 20",
    ASKAMOUNT20: "Satış Hacim 20",
    BIDPRICE18: "Alış Fiyat 18",
    BIDPRICE11: "Alış Fiyat 11",
    BIDPRICE19: "Alış Fiyat 19",
    ASKPRICE12: "Satış Fiyat 12",
    ASKPRICE15: "Satış Fiyat 15",
    ASKAMOUNT24: "Satış Hacim 24",
    ASKQTY11: "Satış Adet 11",
    ASKQTY19: "Satış Adet 19",
    BIDAMOUNT10: "Alış Hacim 10",
    BIDQTY10: "Alış Adet 10",
    ASKAMOUNT16: "Satış Hacim 16",
    ASKAMOUNT22: "Satış Hacim 22",
    ASKQTY18: "Satış Adet 18",
    BIDAMOUNT19: "Alış Hacim 19",
    BIDPRICE20: "Alış Fiyat 20",
    BIDAMOUNT21: "Alış Hacim 21",
    BIDQTY14: "Alış Adet 14",
    ASKPRICE16: "Satış Fiyat 16",
    ASKQTY13: "Satış Adet 13",
    ASKQTY16: "Satış Adet 16",
    BIDAMOUNT14: "Alış Hacim 14",
    BIDQTY19: "Alış Adet 19",
    BIDQTY21: "Alış Adet 21",
    ASKAMOUNT11: "Satış Hacim 11",
    ASKAMOUNT17: "Satış Hacim 17",
    ASKQTY14: "Satış Adet 14",
    BIDAMOUNT13: "Alış Hacim 13",
    BIDPRICE24: "Alış Fiyat 24",
    BIDQTY18: "Alış Adet 18",
    ASKPRICE22: "Satış Fiyat 22",
    ASKQTY20: "Satış Adet 20",
    BIDAMOUNT11: "Alış Hacim 11",
    BIDAMOUNT12: "Alış Hacim 12",
    BIDAMOUNT22: "Alış Hacim 22",
    BIDQTY13: "Alış Adet 13",
    BIDQTY16: "Alış Adet 16",
    ASKAMOUNT14: "Satış Hacim 14",
    ASKAMOUNT23: "Satış Hacim 23",
    ASKQTY10: "Satış Adet 10",
    ASKQTY22: "Satış Adet 22",
    BIDPRICE16: "Alış Fiyat 16",
    BIDPRICE17: "Alış Fiyat 17",
    BIDPRICE22: "Alış Fiyat 22",
    BIDPRICE23: "Alış Fiyat 23",
    ASKAMOUNT19: "Satış Hacim 19",
    ASKQTY12: "Satış Adet 12",
    BIDPRICE14: "Alış Fiyat 14",
    BIDPRICE15: "Alış Fiyat 15",
    BIDQTY17: "Alış Adet 17",
    ASKPRICE11: "Satış Fiyat 11",
    ASKPRICE24: "Satış Fiyat 24",
    ASKAMOUNT15: "Satış Hacim 15",
    BIDAMOUNT24: "Alış Hacim 24",
    ASKPRICE18: "Satış Fiyat 18",
    ASKPRICE19: "Satış Fiyat 19",
    BIDAMOUNT17: "Alış Hacim 17",
    BIDAMOUNT20: "Alış Hacim 20",
    BIDAMOUNT23: "Alış Hacim 23",
    BIDQTY12: "Alış Adet 12",
    ASKAMOUNT21: "Satış Hacim 21",
    ASKQTY15: "Satış Adet 15",
    ASKQTY24: "Satış Adet 24",
    NEWSSOURCEREF: "Haber Kaynak Ref",
    SPLITRATIO: "Bölünme Oranı",
    LASTINCURRENCY: "Döviz Cinsinden Son",
    TOTALTRADECOUNT: "Toplam İşlem Sayısı",
    NEWSBEHALFFUNDTITLE: "Haber Fon Başlığı",
    NEWSBEHALFFUNDID: "Haber Fon Kimliği",
    SPLITRATIODATE: "Bölünme Oranı Tarihi",
    REALESTATEINVESTMENTS: "Gayrimenkul Yatırımları",
    VENTURECAPITALINVESTMENTS: "Girişim Sermayesi Yatırımları",
    FGOLD240M: "F Gold 240M",
    INTRAYEARCLOSE: "Yıl İçi Kapanış",
    INTRAYEARCHANGE: "Yıl İçi Değişim",
    INTRAYEARCHANGEPERCENT: "Yıl İçi Değişim %",
    INTRAWEEKCLOSE: "Hafta İçi Kapanış",
    INTRAWEEKCHANGE: "Hafta İçi Değişim",
    INTRAWEEKCHANGEPERCENT: "Hafta İçi Değişim %",
    INTRAMONTHCLOSE: "Ay İçi Kapanış",
    INTRAMONTHCHANGE: "Ay İçi Değişim",
    INTRAMONTHCHANGEPERCENT: "Ay İçi Değişim %",
    INSTITUTIONALINVESTORSTOCKSIZE: "Kurumsal Yatırımcı Hisse Adedi",
    INSTITUTIONALINVESTORRATIO: "Kurumsal Yatırımcı Oranı",
    INDIVIDUALINVESTORSTOCKSIZE: "Bireysel Yatırımcı Hisse Adedi",
    INDIVIDUALINVESTORRATIO: "Bireysel Yatırımcı Oranı",
    FOREIGNSETTLEMENTRATIO: "Yabancı Takas Oranı",
    FIRSTBROKERBIDTOTALVOLUME: "1. Aracı Alış Toplam Hacim",
    FIRSTBROKERBIDTOTALTURNOVER: "1. Aracı Alış Toplam Ciro",
    FIRSTBROKERASKTOTALVOLUME: "1. Aracı Satış Toplam Hacim",
    FIRSTBROKERASKTOTALTURNOVER: "1. Aracı Satış Toplam Ciro",
    SECONDBROKERBIDTOTALVOLUME: "2. Aracı Alış Toplam Hacim",
    SECONDBROKERBIDTOTALTURNOVER: "2. Aracı Alış Toplam Ciro",
    SECONDBROKERASKTOTALVOLUME: "2. Aracı Satış Toplam Hacim",
    SECONDBROKERASKTOTALTURNOVER: "2. Aracı Satış Toplam Ciro",
    SECONDBIDTRADEBROKER: "2. Alış İşlem Aracısı",
    SECONDASKTRADEBROKER: "2. Satış İşlem Aracısı",
    BIDCOLLATERALPRICE: "Alış Teminat Fiyatı",
    ASKCOLLATERALPRICE: "Satış Teminat Fiyatı",
    PSR: "PSR",
    LEVERAGERATIO: "Kaldıraç Oranı",
    INVESTORCOUNT: "Yatırımcı Sayısı"
  }
};
